import AbrirDialogComposicaoButton from '@/components/shared/AbrirDialogComposicaoButton';
import RelatorChip from '@/components/shared/RelatorChip';
import Tabs from '@/components/shared/Tabs';
import { SITUACAO_IMPEDIMENTOS_PROCESSO } from '@/dominio/SituacaoImpedimentosProcesso';
import SituacaoVoto, { SITUACAO_VOTO } from '@/dominio/SituacaoVoto';
import TipoVoto, { TIPO_VOTO } from '@/dominio/TipoVoto';
import Dominios from '@/util/Dominios';
import ErrorUtil from '@/util/ErrorUtil';
import AddIcon from '@mui/icons-material/Add';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import EditNoteIcon from '@mui/icons-material/EditNote';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PanToolIcon from '@mui/icons-material/PanTool';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckCircle';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import {
    Avatar,
    Box,
    Button,
    createTheme,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    ListItemIcon,
    ListItemText,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';
import { amber, blue, green, grey, red, yellow } from '@mui/material/colors';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/system';
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import InformacoesProcesso from '../../InformacoesProcesso';
import ReactComponent from '../../ReactComponent';
import ModalConfirmacao, { TIPO_CONFIRMACAO } from '../ModalConfirmacao';
import ComparacaoDecisaoRascunhoCertidao from '../PainelDecisao/components/ComparacaoDecisaoRascunhoCertidao';
import RascunhoCertidaoComCarregamento from '../PainelDecisao/components/RascunhoCertidaoComCarregamento';
import ProcessoApregoado from '../ProcessoApregoado';
import DetalheSessaoAnterior from './components/DetalheSessaoAnterior/DetalheSessaoAnterior';
import IconeCadeiraJaVotou from './components/IconeCadeiraJaVotou/IconeCadeiraJaVotou';
import PainelPosicionamentos from './components/PainelPosicionamentos/PainelPosicionamentos';
import PrePreenchimentoSplitButton from './components/PrePreenchimentoSplitButton/PrePreenchimentoSplitButton';
import VerificarInconsistenciasButton from './components/VerificarInconsistenciasButton/VerificarInconsistenciasButton';
import PlacarVotacaoService from './services/PlacarVotacaoService';
import VotacaoService from './services/VotacaoService';

const tema = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            xl: 1537, // 125% (1536px)
            // @ts-ignore
            xxl: 2559 // 75% (2560px)
        }
    }
});

const DialogPainelVotacaoSessao = styled(Dialog)(() => ({
    [tema.breakpoints.between('xs', 'xl')]: {
        '& .MuiDialog-container': {
            '& .MuiPaper-root': {
                minWidth: '95%'
            }
        }
    },
    // @ts-ignore
    [tema.breakpoints.between('xl', 'xxl')]: {
        '& .MuiDialog-container': {
            '& .MuiPaper-root': {
                minWidth: '90%'
            }
        }
    },
    // @ts-ignore
    [tema.breakpoints.up('xxl')]: {
        '& .MuiDialog-container': {
            '& .MuiPaper-root': {
                minWidth: '65%'
            }
        }
    }
}));

const ALTURA_MINIMA_DIALOG_CONTENT = 'calc(100vh - 265px)';
const ALTURA_MAXIMA_DIALOG_CONTENT = ALTURA_MINIMA_DIALOG_CONTENT;

// Configurações
const EXIBIR_MENU_ACIMA_TABELA = false; // Permite configurar para exibir o menu também acima da tabela
const EXIBIR_AVATAR_MAGISTRADO_TITULO_TABELA = true; // Permite configurar para exibir a avatar ou apenas a sigla do ministro no cabeçalho da tabela
const EXIBIR_MENU_DELIBERACAO_RELATOR = false; // Permite configurar para exibir o menu de deliberação para o relator ou não

// Paleta de cores centralizada para o painel de votação
const CORES_PAINEL_VOTACAO = {
    // Cores principais
    relatorVencendo: green[600],
    relatorEmpatado: amber[700],
    relatorPerdendo: red[600],

    relatorVencendoFundoEscuro: green[200],
    relatorEmpatadoFundoEscuro: amber[300],
    relatorPerdendoFundoEscuro: red[200],

    // Cores de status
    sucesso: green[600],
    aviso: amber[600],
    erro: red[600],
    info: blue[600],
    neutro: grey[700],
    sucessoFundoEscuro: green[200],
    avisoFundoEscuro: amber[200],
    erroFundoEscuro: red[200],
    infoFundoEscuro: blue[200],
    neutroFundoEscuro: grey[200],

    // Cores de fundo para tooltips
    tooltipFundo: 'rgba(97, 97, 97, 0.9)', // Cinza escuro com transparência
    tooltipTexto: '#ffffff', // Texto branco

    // Cores para ranking
    primeiroLugar: green[200], // Primeiro lugar (mais votado)
    outrosLugares: 'white', // Outras posições

    // Cores para destaques
    destaqueRelator: blue[100], // Fundo para deliberação do relator
    bordaRelator: blue[500], // Borda para deliberação do relator
    destaqueVencedor: green[50], // Fundo para mais votado
    destaqueEmpate: yellow[50], // Fundo para mais votado
    bordaVencedor: green[500], // Borda para mais votado

    // Cores para ícones de votação
    votoConvergente: TIPO_VOTO.CONVERGENTE.cor,
    votoRessalva: TIPO_VOTO.CONVERGENTE_COM_RESSALVA.cor,
    votoDivergente: TIPO_VOTO.DIVERGENTE.cor,
    votoAusente: TIPO_VOTO.AUSENTE.cor,
    votoImpedido: TIPO_VOTO.IMPEDIDO.cor,
    votoCadeiraJaVotou: TIPO_VOTO.CADEIRA_JA_VOTOU.cor,
    votoNaoDefinido: TIPO_VOTO.SEM_VOTO.cor,
    autorDeliberacaoRelator: blue[500],
    autorDeliberacao: TIPO_VOTO.DIVERGENTE.cor
};

class PainelVotacaoPorMateria extends ReactComponent {
    aberto = false;
    materias = [];
    materiaEmEdicaoId = null;
    materiaInputRef = React.createRef();
    deliberacaoInputRef = React.createRef();
    deliberacaoEmEdicaoId = null;
    menuVotoAnchor = null;
    votoContexto = null;
    menuDeliberacaoAnchor = null;
    menuMateriaAnchor = null;
    materiaSelecionada = null;
    deliberacaoSelecionada = null;
    responsavelEmEdicaoId = null;
    modaisConfirmacaoExclusaoMateria = observable.map(new Map());
    modaisConfirmacaoExclusaoDeliberacaoVoto = observable.map(new Map());
    materiaParaIncluirDeliberacao = null;
    magistradoResponsavelParaIncluirDeliberacao = null;
    openDialogAdicionarDeliberacao = false;
    descricaoInclusaoDeliberacao = null;
    observacaoRelator = null;
    observacaoDivergencias = null;
    observacaoRelatorSalva = '';
    observacaoDivergenciasSalva = '';

    constructor(props) {
        super(props);

        makeObservable(this, {
            aberto: observable,
            abrir: action,
            fechar: action,

            abrirModalConfirmacaoExclusaoMateria: action,
            fecharModalConfirmacaoExclusaoMateria: action,

            abrirModalConfirmacaoExclusaoDeliberacaoVoto: action,
            fecharModalConfirmacaoExclusaoDeliberacaoVoto: action,

            materias: observable,
            adicionarMateria: action,
            materiaEmEdicaoId: observable,
            entrarEmEdicaoMateria: action,
            finalizarEdicaoMateria: action,
            cancelarEdicaoMateria: action,

            deliberacaoEmEdicaoId: observable,
            alterarDeliberacaoEmEdicaoId: action,
            adicionarDeliberacao: action,
            entrarEmEdicaoDeliberacao: action,
            finalizarEdicaoDeliberacao: action,
            cancelarEdicaoDeliberacao: action,

            responsavelEmEdicaoId: observable,
            iniciarEdicaoResponsavel: action,
            finalizarEdicaoResponsavel: action,

            menuVotoAnchor: observable,
            votoContexto: observable,
            abrirMenuVoto: action,
            fecharMenuVoto: action,
            aplicarVoto: action,

            menuDeliberacaoAnchor: observable,
            menuMateriaAnchor: observable,
            materiaSelecionada: observable,
            deliberacaoSelecionada: observable,

            abrirMenuDeliberacao: action,
            fecharMenuDeliberacao: action,
            abrirMenuMateria: action,
            fecharMenuMateria: action,

            excluirDeliberacao: action,
            excluirMateria: action,
            editarAutorDeliberacao: action,

            renderTituloDialog: computed,
            composicaoComVotos: computed,
            renderTabelaControleVotacao: computed,

            renderObservacoes: computed,
            renderProcesso: computed,
            renderSessoesAnteriores: computed,
            renderCertidao: computed,

            cancelarExclusaoMateria: action,
            confirmarExclusaoMateria: action,

            cancelarExclusaoDeliberacao: action,
            confirmarExclusaoDeliberacao: action,

            preencherTodosMateriasAutomaticamente: action,
            preencherVotosAutomaticamente: action,
            preencherDeliberacaoAutomaticamente: action,
            preencherAusentes: action,
            preencherImpedidos: action,
            preencherPossivelmenteImpedidos: action,
            preencherTodosStatus: action,
            preencherMagistradosEmMateria: action,

            renderMenuTabela: computed,

            openDialogAdicionarDeliberacao: observable,
            abrirModalAdicionarDeliberacao: action,
            fecharModalAdicionarDeliberacao: action,
            materiaParaIncluirDeliberacao: observable,
            magistradoResponsavelParaIncluirDeliberacao: observable,
            alterarMagistradoResponsavelParaIncluirDeliberacao: action,
            descricaoInclusaoDeliberacao: observable,
            handleAlteraDescricaoInclusaoDeliberacao: action,

            observacaoRelator: observable,
            handleAlteraObservacaoRelator: action,
            observacaoDivergencias: observable,
            handleAlteraObservacaoDivergencias: action,

            existePosicionamento: computed,
            renderPosicionamentos: computed
        });

        this.createReaction(
            reaction(
                () => this.aberto,
                async () => {
                    if (this.aberto) {
                        try {
                            this.fotoMagistradoStore.carregarFotosPelaComposicaoProcesso(
                                this.observableProps.registro.composicao
                            );
                        } catch (error) {
                            this.mensagemStore.abrirMensagemErro(ErrorUtil.getMensagemErro(error));
                        }

                        const { sessaoId, processo } = this.observableProps.registro;

                        const siglaRelator = this.observableProps.registro.processo.relator.sigla;
                        const materiasResponse = await this.sessaoService.consultarMaterias(
                            sessaoId,
                            processo.numeroCompleto
                        );

                        const materiasComDeliberacoesOrdenadas = materiasResponse.map((materia) => {
                            const deliberacoesComRelatorNoTopo = materia.deliberacoes;
                            const indiceDeliberacaoDoRelator = deliberacoesComRelatorNoTopo.findIndex(
                                (deliberacao) => deliberacao.magistradoResponsavel === siglaRelator
                            );
                            const [deliberacaoDoRelator] = deliberacoesComRelatorNoTopo.splice(
                                indiceDeliberacaoDoRelator,
                                1
                            );
                            deliberacoesComRelatorNoTopo.unshift(deliberacaoDoRelator);

                            return indiceDeliberacaoDoRelator
                                ? {
                                      ...materia,
                                      deliberacoes: deliberacoesComRelatorNoTopo
                                  }
                                : materia;
                        });

                        this.materias = materiasComDeliberacoesOrdenadas;
                    }
                }
            )
        );
    }

    abrir = () => {
        this.aberto = true;
    };

    fechar = () => {
        this.aberto = false;
    };

    abrirModalConfirmacaoExclusaoMateria = (materiaId) => {
        this.modaisConfirmacaoExclusaoMateria.set(materiaId, true);
    };

    fecharModalConfirmacaoExclusaoMateria = (materiaId) => {
        this.modaisConfirmacaoExclusaoMateria.set(materiaId, false);
    };

    abrirModalConfirmacaoExclusaoDeliberacaoVoto = (deliberacaoId) => {
        this.modaisConfirmacaoExclusaoDeliberacaoVoto.set(deliberacaoId, true);
    };

    fecharModalConfirmacaoExclusaoDeliberacaoVoto = (deliberacaoId) => {
        this.modaisConfirmacaoExclusaoDeliberacaoVoto.set(deliberacaoId, false);
    };

    // ----------------------------------------------------- Matéria

    abrirMenuMateria = (event, materia) => {
        event.stopPropagation();
        this.menuMateriaAnchor = event.currentTarget;
        this.materiaSelecionada = materia;
    };

    fecharMenuMateria = () => {
        this.menuMateriaAnchor = null;
    };

    adicionarMateria = async () => {
        const siglaRelator = this.observableProps.registro.processo.relator.sigla;
        const novaMateria = VotacaoService.criarNovaMateria(siglaRelator);

        try {
            const { sessaoId, processo } = this.observableProps.registro;
            const responseMateria = await this.sessaoService.cadastrarMateria(
                sessaoId,
                processo.numeroCompleto,
                novaMateria
            );
            this.materias.push(responseMateria.data);
        } catch (err) {
            console.error(err);
            this.mensagemStore.abrirMensagemErro('Erro ao incluir matéria. Tente novamente.');
        }
    };

    entrarEmEdicaoMateria = (materia) => {
        if (!materia) return;

        this.materiaEmEdicaoId = materia.id;

        requestAnimationFrame(() => {
            const input = this.materiaInputRef.current;

            if (input) {
                input.value = materia.descricao ?? '';
                input.focus();
                input.select();
            }
        });

        this.fecharMenuMateria();
    };

    finalizarEdicaoMateria = async (materiaId, novaDescricao) => {
        const descricaoTrim = novaDescricao?.trim();

        if (!descricaoTrim) {
            this.mensagemStore.abrirMensagemAlerta('A descrição da matéria não pode ficar em branco.');
            return;
        }

        try {
            await this.sessaoService.alterarDescricaoMateria(materiaId, novaDescricao);
            this.materiaEmEdicaoId = null;
            const materia = this.materias.find((t) => t.id === materiaId);
            materia.descricao = descricaoTrim;
        } catch (error) {
            console.error(error);
            this.mensagemStore.abrirMensagemErro('Erro ao alterar descrição da matéria. Tente novamente.');
        }
    };

    cancelarEdicaoMateria = () => {
        this.materiaEmEdicaoId = null;
    };

    confirmarExclusaoMateria = async (materiaSelecionada) => {
        if (!materiaSelecionada?.id) {
            return;
        }

        try {
            await this.sessaoService.excluirMateria(materiaSelecionada?.id);

            this.fecharMenuMateria();
            this.abrirModalConfirmacaoExclusaoMateria(materiaSelecionada.id);
        } catch (error) {
            console.error(error);
            this.mensagemStore.abrirMensagemErro('Erro ao excluir matéria. Tente novamente.');
        }
    };

    cancelarExclusaoMateria = (materiaSelecionada) => {
        this.fecharModalConfirmacaoExclusaoMateria(materiaSelecionada.id);
        this.mensagemStore.abrirMensagemAlerta(`Exclusão da matéria "${materiaSelecionada.descricao}" cancelada!`);
    };

    excluirMateria = async (materiaSelecionada) => {
        await new Promise((r) => setTimeout(r, 2000)); // MOCK DE PROCESSAMENTO
        this.materias = this.materias.filter((t) => t.id !== materiaSelecionada.id); // EXCLUSÃO APENAS NO FRONTEND

        this.fecharModalConfirmacaoExclusaoMateria(materiaSelecionada.id);
        this.mensagemStore.abrirMensagemSucesso('Matéria excluída com sucesso');
    };

    // ----------------------------------------------------- Deliberação (sentido do voto)

    abrirMenuDeliberacao = (event, materia, deliberacao) => {
        event.stopPropagation();
        this.menuDeliberacaoAnchor = event.currentTarget;
        this.materiaSelecionada = materia;
        this.deliberacaoSelecionada = deliberacao;
    };

    fecharMenuDeliberacao = () => {
        this.menuDeliberacaoAnchor = null;
    };

    abrirModalAdicionarDeliberacao = (materia) => {
        this.materiaParaIncluirDeliberacao = materia;
        this.descricaoInclusaoDeliberacao = '';
        this.openDialogAdicionarDeliberacao = true;
    };

    fecharModalAdicionarDeliberacao = () => {
        this.materiaParaIncluirDeliberacao = null;
        this.magistradoResponsavelParaIncluirDeliberacao = null;
        this.openDialogAdicionarDeliberacao = false;
    };

    alterarDeliberacaoEmEdicaoId = (deliberacaoEmEdicaoId) => {
        this.deliberacaoEmEdicaoId = deliberacaoEmEdicaoId;
    };

    adicionarDeliberacao = async () => {
        this.fecharMenuMateria();

        if (!this.magistradoResponsavelParaIncluirDeliberacao) {
            this.mensagemStore.abrirMensagemAlerta('Selecione um magistrado para incluir uma nova deliberação.');
            return;
        }

        if (!this.descricaoInclusaoDeliberacao) {
            this.mensagemStore.abrirMensagemAlerta('Informe uma descrição para incluir uma nova deliberação.');
            return;
        }

        const siglaRelator = this.observableProps.registro.processo.relator.sigla;
        const novaDeliberacao = VotacaoService.criarNovaDeliberacao(
            this.materiaParaIncluirDeliberacao,
            siglaRelator,
            this.magistradoResponsavelParaIncluirDeliberacao,
            this.descricaoInclusaoDeliberacao
        );

        if (novaDeliberacao) {
            try {
                const responseDeliberacao = await this.sessaoService.cadastrarDeliberacao(
                    this.materiaParaIncluirDeliberacao.id,
                    novaDeliberacao
                );
                this.materiaParaIncluirDeliberacao.deliberacoes.push(responseDeliberacao.data);
                this.fecharModalAdicionarDeliberacao();
            } catch (error) {
                console.error(error);
                this.mensagemStore.abrirMensagemErro('Erro ao incluir deliberação. Tente novamente.');
            }
        }
    };

    entrarEmEdicaoDeliberacao = (materia, deliberacao) => {
        if (!materia) return;
        if (!deliberacao) return;

        this.alterarDeliberacaoEmEdicaoId(deliberacao.id);

        requestAnimationFrame(() => {
            const input = this.deliberacaoInputRef.current;

            if (input) {
                input.value = deliberacao.descricao ?? '';
                input.focus();
                input.select();
            }
        });

        this.fecharMenuDeliberacao();
    };

    finalizarEdicaoDeliberacao = async (materiaId, deliberacaoId, novaDescricao) => {
        const descricaoTrim = novaDescricao?.trim();

        if (!descricaoTrim) {
            this.mensagemStore.abrirMensagemAlerta('A descrição da deliberação não pode ficar em branco.');
            return;
        }

        try {
            await this.sessaoService.alterarDescricaoDeliberacao(deliberacaoId, novaDescricao);
            const materia = this.materias.find((t) => t.id === materiaId);
            const deliberacao = materia.deliberacoes.find((o) => o.id === deliberacaoId);

            deliberacao.descricao = descricaoTrim;
            this.alterarDeliberacaoEmEdicaoId(null);
        } catch (error) {
            console.error(error);
            this.mensagemStore.abrirMensagemErro('Erro ao alterar descrição da matéria. Tente novamente.');
        }
    };

    cancelarEdicaoDeliberacao = () => {
        this.deliberacaoEmEdicaoId = null;
    };

    iniciarEdicaoResponsavel = (deliberacaoId) => {
        this.responsavelEmEdicaoId = deliberacaoId;
        this.deliberacaoEmEdicaoId = null; // Garante que não edite a descrição
    };

    finalizarEdicaoResponsavel = async (deliberacao, novaSigla) => {
        const magistradoResponsavelAtual = deliberacao.magistradoResponsavel;

        if (magistradoResponsavelAtual === novaSigla) {
            return;
        }

        const siglaRelator = this.observableProps.registro.processo.relator.sigla;

        // Verifica se está tentando mudar a deliberação do relator para outra pessoa
        if (deliberacao.magistradoResponsavel === siglaRelator && novaSigla !== siglaRelator) {
            this.mensagemStore.abrirMensagemErro('Não é possível alterar o relator!');
            this.responsavelEmEdicaoId = null; // Limpar estado mesmo em caso de erro
            return;
        }

        try {
            // Remove votos do autor antigo
            const votoAutorAnterior = await this.sessaoService.incluirVotoDeliberacao(
                deliberacao.id,
                magistradoResponsavelAtual,
                TIPO_VOTO.SEM_VOTO.codigo
            );
            deliberacao.votos = deliberacao.votos.map((v) => {
                return v.magistradoResponsavel === magistradoResponsavelAtual ? votoAutorAnterior.data : v;
            });

            // Atualiza o autor
            await this.sessaoService.alterarMagistradoResponsavelDeliberacao(deliberacao.id, novaSigla);
            deliberacao.magistradoResponsavel = novaSigla;

            // Garante que o novo autor vote na deliberação
            const votoNovoAutor = await this.sessaoService.incluirVotoDeliberacao(
                deliberacao.id,
                novaSigla,
                TIPO_VOTO.CONVERGENTE.codigo
            );
            deliberacao.votos?.push(votoNovoAutor.data);

            this.responsavelEmEdicaoId = null;
        } catch (error) {
            console.error(error);
            this.mensagemStore.abrirMensagemErro(
                'Erro ao alterar magistrado responsável da deliberação. Tente novamente.'
            );
        }
    };

    /**
     * Determina o voto padrão baseado no status do magistrado
     * @param {object} mag - Magistrado da composição
     * @returns {number|null} - Código do tipo de voto ou null se não aplicável
     */
    obterVotoPadraoPeloStatus = (mag) => {
        const siglaRelator = this.observableProps.registro.processo.relator.sigla;
        return VotacaoService.obterVotoPadraoPeloStatus(mag, siglaRelator);
    };

    /**
     * Pré-preenche automaticamente os votos baseado no status dos magistrados
     * @param {object} materia - Materia a ser pré-preenchido
     */
    preencherVotosAutomaticamente = (materia) => {
        if (!materia?.deliberacoes || !this.composicaoComVotos) {
            return;
        }

        const siglaRelator = this.observableProps.registro.processo.relator.sigla;

        const materiaPreenchida = VotacaoService.preencherVotosAutomaticamente(
            materia,
            this.composicaoComVotos,
            siglaRelator
        );

        // Atualiza o materia com os votos pré-preenchidos
        runInAction(() => {
            materia.deliberacoes = materiaPreenchida.deliberacoes;
        });
    };

    incluirVotosEmLote = async (materia, deliberacao, magistrados, tipoVoto) => {
        const preenchimentosVotoPromises = [];

        if (materia) {
            // Pré-preenche os votos de uma matéria específica
            if (deliberacao) {
                for (const magistrado of magistrados) {
                    preenchimentosVotoPromises.push(
                        this.sessaoService.incluirVotoDeliberacao(
                            deliberacao.id,
                            magistrado.siglaDoMagistrado,
                            tipoVoto
                        )
                    );
                }
                await Promise.all(preenchimentosVotoPromises);
            } else {
                for (const deliberacao of materia.deliberacoes) {
                    for (const magistrado of magistrados) {
                        preenchimentosVotoPromises.push(
                            this.sessaoService.incluirVotoDeliberacao(
                                deliberacao.id,
                                magistrado.siglaDoMagistrado,
                                tipoVoto
                            )
                        );
                    }
                }
                await Promise.all(preenchimentosVotoPromises);
            }
            this.preencherMagistradosEmMateria(materia, magistrados, tipoVoto, deliberacao);
        } else {
            const preenchimentoMagistradosFrontend = [];

            // Pré-preenche em todos as matérias
            for (const materia of this.materias) {
                for (const deliberacao of materia.deliberacoes) {
                    for (const magistrado of magistrados) {
                        preenchimentosVotoPromises.push(
                            this.sessaoService.incluirVotoDeliberacao(
                                deliberacao.id,
                                magistrado.siglaDoMagistrado,
                                tipoVoto
                            )
                        );
                    }
                }

                preenchimentoMagistradosFrontend.push({
                    materia,
                    magistrados,
                    tipoVoto,
                    deliberacao
                });
            }

            await Promise.all(preenchimentosVotoPromises);

            for (const { materia, magistrados, tipoVoto, deliberacao } of preenchimentoMagistradosFrontend) {
                this.preencherMagistradosEmMateria(materia, magistrados, tipoVoto, deliberacao);
            }
        }
    };

    /**
     * Pré-preenche apenas magistrados ausentes
     */
    preencherAusentes = async (materia, deliberacao = null) => {
        if (!this.composicaoComVotos) return;

        const magistradosAusentes = this.composicaoComVotos.filter((mag) => mag.ausente);

        try {
            await this.incluirVotosEmLote(materia, deliberacao, magistradosAusentes, TIPO_VOTO.AUSENTE.codigo);
            const count = magistradosAusentes.length;

            if (count > 0) {
                const plural = count === 1 ? '' : 's';
                this.mensagemStore.abrirMensagemSucesso(
                    `${count} magistrado${plural} ausente${plural} pré-preenchido${plural} como "Ausente"`
                );
            }
        } catch (error) {
            console.error(error);
            this.mensagemStore.abrirMensagemErro('Erro ao pré-preencher magistrados ausentes. Tente novamente.');
        }
    };

    /**
     * Pré-preenche apenas magistrados impedidos
     */
    preencherImpedidos = async (materia, deliberacao = null) => {
        if (!this.composicaoComVotos) return;

        const magistradosImpedidos = this.composicaoComVotos.filter((mag) => mag.impedido);

        await this.incluirVotosEmLote(materia, deliberacao, magistradosImpedidos, TIPO_VOTO.IMPEDIDO.codigo);

        const count = magistradosImpedidos.length;

        if (count > 0) {
            const plural = count === 1 ? '' : 's';
            this.mensagemStore.abrirMensagemSucesso(
                `${count} magistrado${plural} impedido${plural} pré-preenchido${plural} como "Impedido"`
            );
        }
    };

    /**
     * Pré-preenche apenas magistrados possivelmente impedidos
     */
    preencherPossivelmenteImpedidos = async (materia, deliberacao = null) => {
        if (!this.composicaoComVotos) return;

        const magistradosPossivelmenteImpedidos = this.composicaoComVotos.filter(
            (mag) => mag.possivelmenteImpedido && !mag.impedido
        );

        await this.incluirVotosEmLote(
            materia,
            deliberacao,
            magistradosPossivelmenteImpedidos,
            TIPO_VOTO.IMPEDIDO.codigo
        );

        const count = magistradosPossivelmenteImpedidos.length;

        if (count > 0) {
            const plural = count === 1 ? '' : 's';
            this.mensagemStore.abrirMensagemSucesso(
                `${count} magistrado${plural} possivelmente impedido${plural} pré-preenchido${plural} como "Impedido"`
            );
        }
    };

    /**
     * Método genérico para pré-preenchimento
     */
    preencherMagistradosEmMateria = (materia, magistrados, tipoVotoId, deliberacaoEspecifica = null) => {
        if (!materia?.deliberacoes || !magistrados || magistrados.length === 0) return;

        const deliberacoesParaPreencher = deliberacaoEspecifica ? [deliberacaoEspecifica] : materia.deliberacoes;

        for (const deliberacao of deliberacoesParaPreencher) {
            for (const mag of magistrados) {
                const siglaMag = mag.siglaDoMagistrado;

                // Não pré-preenche autor votando em sua própria deliberação
                if (siglaMag === deliberacao.magistradoResponsavel) continue;

                // Não sobrescreve votos existentes
                const votoExistente = deliberacao.votos?.find((v) => v.magistradoResponsavel === siglaMag);

                if (votoExistente) continue;

                // Atribui o voto
                deliberacao.votos = deliberacao.votos || [];
                deliberacao.votos.push({
                    magistradoResponsavel: siglaMag,
                    tipo: { id: tipoVotoId }
                });
            }
        }
    };

    /**
     * Pré-preenche tudo de uma vez
     */
    preencherTodosStatus = (materia = null) => {
        this.preencherAusentes(materia);
        this.preencherImpedidos(materia);
        this.preencherPossivelmenteImpedidos(materia);

        this.mensagemStore.abrirMensagemSucesso(
            'Todos os não votantes (ausentes, impedidos e possivelmente impedidos) pré-preenchidos'
        );
    };

    /**
     * Pré-preenche todos os materias automaticamente
     */
    preencherTodosMateriasAutomaticamente = () => {
        const siglaRelator = this.observableProps.registro.processo.relator.sigla;

        runInAction(() => {
            this.materias.forEach((materia) => {
                const materiaPreenchida = VotacaoService.preencherVotosAutomaticamente(
                    materia,
                    this.composicaoComVotos,
                    siglaRelator
                );

                materia.deliberacoes = materiaPreenchida.deliberacoes;
            });
        });

        this.mensagemStore.abrirMensagemSucesso('Ausências e impedimentos pré-preenchidos automaticamente');
    };

    /**
     * Pré-preenche uma deliberação específica
     */
    preencherDeliberacaoAutomaticamente = (materia, deliberacao) => {
        if (!materia || !deliberacao || !this.composicaoComVotos) {
            return;
        }

        const siglaRelator = this.observableProps.registro.processo.relator.sigla;
        const isDeliberacaoRelator = deliberacao.magistradoResponsavel === siglaRelator;

        this.composicaoComVotos.forEach((mag) => {
            const siglaMag = mag.siglaDoMagistrado;

            // Autor da deliberação vota automaticamente como convergente
            const isAutor = siglaMag === deliberacao.magistradoResponsavel;

            if (isAutor && !isDeliberacaoRelator) {
                VotacaoService.adicionarVotoSeNaoExistir(deliberacao, siglaMag, TIPO_VOTO.CONVERGENTE.codigo);
                return;
            }

            // Se não é autor, verifica status para pré-preenchimento
            const votoPadrao = VotacaoService.obterVotoPadraoPeloStatus(mag);

            if (votoPadrao !== null) {
                VotacaoService.adicionarVotoSeNaoExistir(deliberacao, siglaMag, votoPadrao);
            }
        });
    };

    editarAutorDeliberacao = () => {
        const { deliberacaoSelecionada } = this;

        if (!deliberacaoSelecionada) {
            this.mensagemStore.abrirMensagemErro('Nenhuma deliberação selecionada.');
            return;
        }

        this.responsavelEmEdicaoId = deliberacaoSelecionada.id;
        this.alterarDeliberacaoEmEdicaoId(null); // Garantir que não entre em edição de descrição

        this.fecharMenuDeliberacao();

        console.debug(
            'Editando autor da deliberação:',
            deliberacaoSelecionada.id,
            'responsavelEmEdicaoId:',
            this.responsavelEmEdicaoId
        );
    };

    confirmarExclusaoDeliberacao = (deliberacaoSelecionada) => {
        this.abrirModalConfirmacaoExclusaoDeliberacaoVoto(deliberacaoSelecionada.id);
    };

    cancelarExclusaoDeliberacao = (deliberacaoSelecionada) => {
        this.fecharModalConfirmacaoExclusaoDeliberacaoVoto(deliberacaoSelecionada.id);
        this.mensagemStore.abrirMensagemAlerta(
            `Exclusão da deliberação de votação "${deliberacaoSelecionada.descricao}" cancelada!`
        );
        this.fecharMenuDeliberacao();
    };

    verificarSeMagistradoTemVotoConvergenteNaMateria = (materia, magistradoSigla, deliberacaoAtualId) => {
        return VotacaoService.verificarSeMagistradoTemVotoConvergenteNaMateria(
            this.materias,
            materia.id,
            magistradoSigla,
            deliberacaoAtualId
        );
    };

    excluirDeliberacao = async (materiaSelecionada, deliberacaoSelecionada) => {
        const siglaRelator = this.observableProps.registro.processo.relator.sigla;

        // Verifica se é a deliberação do relator
        if (deliberacaoSelecionada.magistradoResponsavel === siglaRelator) {
            this.mensagemStore.abrirMensagemErro('Não é possível excluir a deliberação do relator!');
            this.fecharMenuDeliberacao();
            return;
        }

        try {
            await this.sessaoService.excluirDeliberacao(deliberacaoSelecionada?.id);

            materiaSelecionada.deliberacoes = materiaSelecionada.deliberacoes.filter(
                (o) => o.id !== deliberacaoSelecionada.id
            );

            this.materiaSelecionada = materiaSelecionada;
            this.fecharModalConfirmacaoExclusaoDeliberacaoVoto(deliberacaoSelecionada.id);
            this.mensagemStore.abrirMensagemSucesso(
                `Deliberação "${deliberacaoSelecionada.descricao}" excluída com sucesso `
            );
            this.fecharMenuDeliberacao();
        } catch (error) {
            console.error(error);
            this.mensagemStore.abrirMensagemErro('Erro ao excluir deliberação. Tente novamente.');
        }
    };

    // ------------------------------------------------------------------ Voto

    abrirMenuVoto = (event, materia, deliberacao, magistradoSigla) => {
        this.menuVotoAnchor = event.currentTarget;
        this.votoContexto = { materia, deliberacao, magistradoSigla };
    };

    fecharMenuVoto = () => {
        this.menuVotoAnchor = null;
        this.votoContexto = null;
    };

    aplicarVoto = async (tipoVotoId) => {
        const { materia, deliberacao, magistradoSigla } = this.votoContexto;

        if (!deliberacao || !materia) {
            return;
        }

        const votoAtual = deliberacao.votos?.find((v) => v.magistradoResponsavel === magistradoSigla);
        const tipoVotoAtual = votoAtual?.tipo?.id;

        const isVotoConvergenteAtual =
            tipoVotoAtual === TIPO_VOTO.CONVERGENTE.codigo ||
            tipoVotoAtual === TIPO_VOTO.CONVERGENTE_COM_RESSALVA.codigo;

        const isNovoVotoConvergente =
            tipoVotoId === TIPO_VOTO.CONVERGENTE.codigo || tipoVotoId === TIPO_VOTO.CONVERGENTE_COM_RESSALVA.codigo;

        const resultado = VotacaoService.aplicarVoto(materia, deliberacao, magistradoSigla, tipoVotoId, this.materias);

        if (resultado.sucesso) {
            try {
                await this.sessaoService.incluirVotoDeliberacao(deliberacao.id, magistradoSigla, tipoVotoId);

                deliberacao.votos = resultado.votosAtualizados;

                const isRemovendoVotoConvergente = isVotoConvergenteAtual && !isNovoVotoConvergente;

                if (isRemovendoVotoConvergente) {
                    this.mensagemStore.abrirMensagemSucesso(
                        'Voto convergente removido. Agora é possível votar convergentemente em outra deliberação.'
                    );
                }
            } catch (error) {
                console.error(error);
                this.mensagemStore.abrirMensagemErro('Não foi possível incluir o voto. Tente novamente.');
            }
        } else {
            this.mensagemStore.abrirMensagemErro(resultado.erro);
        }

        this.fecharMenuVoto();
    };

    renderMenuVotos = () => {
        const { materia, deliberacao, magistradoSigla } = this.votoContexto || {};
        const votoAtual = deliberacao?.votos?.find((v) => v.magistradoResponsavel === magistradoSigla);
        const tipoVotoAtualId = votoAtual?.tipo?.id;

        // Verificar se já tem voto convergente em OUTRA deliberação
        const jaTemVotoConvergenteOutraDeliberacao =
            materia && magistradoSigla
                ? VotacaoService.verificarSeMagistradoTemVotoConvergenteNaMateria(
                      this.materias,
                      materia.id,
                      magistradoSigla,
                      deliberacao?.id
                  )
                : false;

        return (
            <Menu
                anchorEl={this.menuVotoAnchor}
                open={Boolean(this.menuVotoAnchor)}
                onClose={this.fecharMenuVoto}
            >
                {/* Opções de VOTO (Convergente, Convergente com Ressalva, Divergente) */}

                {/* Acompanha (Convergente) */}
                <MenuItem
                    onClick={() => this.aplicarVoto(TIPO_VOTO.CONVERGENTE.codigo)}
                    disabled={jaTemVotoConvergenteOutraDeliberacao || tipoVotoAtualId === TIPO_VOTO.CONVERGENTE.codigo}
                >
                    <ListItemIcon>
                        <CheckCircleIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>
                        <Box>
                            Acompanha
                            {!!jaTemVotoConvergenteOutraDeliberacao &&
                                tipoVotoAtualId !== TIPO_VOTO.CONVERGENTE.codigo && (
                                    <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        display="block"
                                    >
                                        Já votou convergentemente em outra deliberação
                                    </Typography>
                                )}
                            {tipoVotoAtualId === TIPO_VOTO.CONVERGENTE.codigo && (
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                >
                                    Voto atual
                                </Typography>
                            )}
                        </Box>
                    </ListItemText>
                </MenuItem>

                {/* Acompanha com ressalva */}
                <MenuItem
                    onClick={() => this.aplicarVoto(TIPO_VOTO.CONVERGENTE_COM_RESSALVA.codigo)}
                    disabled={
                        jaTemVotoConvergenteOutraDeliberacao ||
                        tipoVotoAtualId === TIPO_VOTO.CONVERGENTE_COM_RESSALVA.codigo
                    }
                >
                    <ListItemIcon>
                        <PlaylistAddCheckCircleIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>
                        <Box>
                            Acompanha com ressalva
                            {!!jaTemVotoConvergenteOutraDeliberacao &&
                                tipoVotoAtualId !== TIPO_VOTO.CONVERGENTE_COM_RESSALVA.codigo && (
                                    <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        display="block"
                                    >
                                        Já votou convergentemente em outra deliberação
                                    </Typography>
                                )}
                            {tipoVotoAtualId === TIPO_VOTO.CONVERGENTE_COM_RESSALVA.codigo && (
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                >
                                    Voto atual
                                </Typography>
                            )}
                        </Box>
                    </ListItemText>
                </MenuItem>

                {/* Diverge */}
                <MenuItem
                    onClick={() => this.aplicarVoto(TIPO_VOTO.DIVERGENTE.codigo)}
                    disabled={tipoVotoAtualId === TIPO_VOTO.DIVERGENTE.codigo}
                >
                    <ListItemIcon>
                        <CallSplitIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>
                        <Box>
                            Diverge
                            {tipoVotoAtualId === TIPO_VOTO.DIVERGENTE.codigo && (
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                >
                                    Voto atual
                                </Typography>
                            )}
                        </Box>
                    </ListItemText>
                </MenuItem>

                {/* PRIMEIRO DIVIDER: Separa opções de voto de não-voto */}
                <Divider />

                {/* Opções de NÃO-VOTO (Ausente, Impedido) */}

                {/* Ausente */}
                <MenuItem
                    onClick={() => this.aplicarVoto(TIPO_VOTO.AUSENTE.codigo)}
                    disabled={tipoVotoAtualId === TIPO_VOTO.AUSENTE.codigo}
                >
                    <ListItemIcon>
                        <LocationOffIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>
                        <Box>
                            Ausente
                            {tipoVotoAtualId === TIPO_VOTO.AUSENTE.codigo && (
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                >
                                    Seleção atual
                                </Typography>
                            )}
                        </Box>
                    </ListItemText>
                </MenuItem>

                {/* Impedido */}
                <MenuItem
                    onClick={() => this.aplicarVoto(TIPO_VOTO.IMPEDIDO.codigo)}
                    disabled={tipoVotoAtualId === TIPO_VOTO.IMPEDIDO.codigo}
                >
                    <ListItemIcon>
                        <PanToolIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>
                        <Box>
                            Impedido
                            {tipoVotoAtualId === TIPO_VOTO.IMPEDIDO.codigo && (
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                >
                                    Seleção atual
                                </Typography>
                            )}
                        </Box>
                    </ListItemText>
                </MenuItem>

                {/* Cadeira já votou */}
                <MenuItem
                    onClick={() => this.aplicarVoto(TIPO_VOTO.CADEIRA_JA_VOTOU.codigo)}
                    disabled={tipoVotoAtualId === TIPO_VOTO.CADEIRA_JA_VOTOU.codigo}
                >
                    <ListItemIcon>
                        <IconeCadeiraJaVotou
                            tonsDeCinza={true}
                            fontSize="small"
                        />
                    </ListItemIcon>
                    <ListItemText>
                        <Box>
                            Cadeira já votou
                            {tipoVotoAtualId === TIPO_VOTO.CADEIRA_JA_VOTOU.codigo && (
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                >
                                    Seleção atual
                                </Typography>
                            )}
                        </Box>
                    </ListItemText>
                </MenuItem>

                {/* SEGUNDO DIVIDER: Separa a opção de Limpar */}
                <Divider />

                {/* Limpar voto - SEMPRE disponível se houver voto atual */}
                {votoAtual ? (
                    <MenuItem onClick={() => this.aplicarVoto(TIPO_VOTO.SEM_VOTO.codigo)}>
                        <ListItemIcon>
                            <CleaningServicesIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Limpar voto</ListItemText>
                    </MenuItem>
                ) : (
                    <MenuItem disabled>
                        <ListItemIcon>
                            <CleaningServicesIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>
                            <Box>
                                Limpar voto
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                >
                                    Já está sem voto
                                </Typography>
                            </Box>
                        </ListItemText>
                    </MenuItem>
                )}
            </Menu>
        );
    };

    handleConfirmarPreenchimento = (tipo) => {
        switch (tipo) {
            case 'ausentes':
                this.preencherAusentes();
                break;
            case 'impedidos':
                this.preencherImpedidos();
                break;
            case 'possivelmenteImpedidos':
                this.preencherPossivelmenteImpedidos();
                break;
            default:
                break;
        }
    };

    verificarInconsistencias = () => {
        const siglaRelator = this.observableProps.registro.processo.relator.sigla;
        return VotacaoService.verificarInconsistencias(this.materias, siglaRelator);
    };

    /**
     * Exibe o relatório de inconsistências
     */
    exibirRelatorioInconsistencias = () => {
        const inconsistencias = this.verificarInconsistencias();

        if (inconsistencias.totalInconsistencias === 0) {
            this.mensagemStore.abrirMensagemSucesso('✅ Nenhuma inconsistência encontrada!');
            return;
        }

        this.abrirDialogInconsistencias(inconsistencias);
    };

    handleAcaoSelecionada = (tipo) => {
        switch (tipo) {
            case 'ausentes':
                this.preencherAusentes();
                break;
            case 'impedidos':
                this.preencherImpedidos();
                break;
            case 'possivelmenteImpedidos':
                this.preencherPossivelmenteImpedidos();
                break;
            case 'todosNaoVotantes':
                this.preencherTodosStatus();
                break;
            default:
                break;
        }
    };

    get renderBotoesPreenchimento() {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    flexWrap: 'wrap',
                    justifyContent: 'flex-end',
                    mb: 2
                }}
            >
                <PrePreenchimentoSplitButton
                    composicao={this.composicaoComVotos}
                    onAcaoSelecionada={this.handleAcaoSelecionada}
                    variant="contained"
                    color="primary"
                />
            </Box>
        );
    }

    renderCelulaVotoEstilo = (magistradoSigla, materia, deliberacao) => {
        const voto = deliberacao.votos.find((v) => v.magistradoResponsavel === magistradoSigla);
        const jaTemVotoConvergente = VotacaoService.verificarSeMagistradoTemVotoConvergenteNaMateria(
            this.materias,
            materia.id,
            magistradoSigla,
            deliberacao.id
        );

        const isAutor = magistradoSigla === deliberacao.magistradoResponsavel;

        let estilo = {};

        if (isAutor) {
            return {}; // Autor sempre pode votar na sua própria deliberação
        }

        if (
            jaTemVotoConvergente &&
            (!voto ||
                (voto.tipo?.id !== TIPO_VOTO.CONVERGENTE.codigo &&
                    voto.tipo?.id !== TIPO_VOTO.CONVERGENTE_COM_RESSALVA.codigo &&
                    voto.tipo?.id !== TIPO_VOTO.RELATOR.codigo))
        ) {
            // Magistrado já tem voto convergente em outra deliberação
            estilo = {
                opacity: 0.5,
                cursor: 'not-allowed',
                position: 'relative',
                '&::after': {
                    content: '"🚫"',
                    position: 'absolute',
                    top: 2,
                    right: 2,
                    fontSize: '0.7rem'
                }
            };
        }

        return estilo;
    };

    obterEstadoVotosMagistradoPorMateria = (materia, magistradoSigla) => {
        return PlacarVotacaoService.obterEstadoVotosMagistradoPorMateria(materia, magistradoSigla);
    };

    renderIconeVotoDeliberacao = (voto, isAutor) => {
        switch (voto?.tipo?.id) {
            case TIPO_VOTO.RELATOR.codigo:
                return (
                    <Tooltip title={<Typography>Autor do votor condutor (relator)</Typography>}>
                        <LightbulbIcon sx={{ color: CORES_PAINEL_VOTACAO.autorDeliberacaoRelator }} />
                    </Tooltip>
                );

            case TIPO_VOTO.CONVERGENTE.codigo:
                if (isAutor) {
                    return this.renderIconeVotoAutorDeliberacao();
                }
                return <HowToVoteIcon sx={{ color: CORES_PAINEL_VOTACAO.votoConvergente }} />;

            case TIPO_VOTO.CONVERGENTE_COM_RESSALVA.codigo:
                return <HowToVoteIcon sx={{ color: CORES_PAINEL_VOTACAO.votoRessalva }} />;

            case TIPO_VOTO.DIVERGENTE.codigo:
                return <HowToVoteIcon sx={{ color: CORES_PAINEL_VOTACAO.votoDivergente }} />;

            case TIPO_VOTO.AUSENTE.codigo:
                return <LocationOffIcon sx={{ color: CORES_PAINEL_VOTACAO.votoAusente }} />;

            case TIPO_VOTO.IMPEDIDO.codigo:
                return <PanToolIcon sx={{ color: CORES_PAINEL_VOTACAO.votoImpedido }} />;

            case TIPO_VOTO.CADEIRA_JA_VOTOU.codigo:
                return <IconeCadeiraJaVotou tonsDeCinza={false} />;

            default:
                return <QuestionMarkIcon sx={{ color: CORES_PAINEL_VOTACAO.votoNaoDefinido }} />;
        }
    };

    renderIconeVotoAutorDeliberacao = () => {
        return (
            <Tooltip title={<Typography>Autor do voto divergente</Typography>}>
                <LightbulbIcon sx={{ color: CORES_PAINEL_VOTACAO.autorDeliberacao }} />
            </Tooltip>
        );
    };

    contarVotosDeliberacao = (deliberacao) => {
        return PlacarVotacaoService.contarVotosDeliberacao(deliberacao);
    };

    obterDeliberacaoVencedora = (materia) => {
        return PlacarVotacaoService.obterDeliberacaoVencedora(materia);
    };

    /**
     * Auxilia na verificação de deliberações empatadas no primeiro lugar
     */
    obterDeliberacoesEmpatadas = (materia) => {
        return PlacarVotacaoService.obterDeliberacoesEmpatadas(materia);
    };

    /**
     * Verifica se há empate
     */
    haEmpateNaMateria = (materia) => {
        return PlacarVotacaoService.haEmpateNaMateria(materia);
    };

    getDescricaoEmpate = (grupoEmpate) => {
        return PlacarVotacaoService.getDescricaoEmpate(grupoEmpate);
    };

    renderPlacarDeliberacao = (deliberacao) => {
        const placar = PlacarVotacaoService.calcularPlacarDeliberacao(deliberacao);

        if (!placar) {
            return null;
        }

        // Conteúdo do Tooltip
        const renderDetalhesTooltip = () => (
            <Box sx={{ p: 1, maxWidth: 300 }}>
                <Typography
                    variant="subtitle2"
                    sx={{
                        fontWeight: 'bold',
                        mb: 1,
                        color: '#ffffff'
                    }}
                >
                    Placar da deliberação
                </Typography>

                <Typography
                    variant="body2"
                    sx={{
                        mb: 1,
                        color: 'rgba(255, 255, 255, 0.9)'
                    }}
                >
                    <strong style={{ color: CORES_PAINEL_VOTACAO.infoFundoEscuro }}>Autor:</strong>{' '}
                    {deliberacao.magistradoResponsavel}
                </Typography>

                <Typography
                    variant="body2"
                    sx={{
                        mb: 2,
                        color: 'rgba(255, 255, 255, 0.9)'
                    }}
                >
                    <strong style={{ color: CORES_PAINEL_VOTACAO.infoFundoEscuro }}>Descrição:</strong>{' '}
                    {deliberacao.descricao || 'Sem descrição'}
                </Typography>

                <Box sx={{ mb: 1 }}>
                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 'bold',
                            mb: 0.5,
                            color: '#ffffff'
                        }}
                    >
                        Contagem de Votos:
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{ color: 'rgba(255, 255, 255, 0.9)' }}
                    >
                        • Autor da deliberação de voto:{' '}
                        <span
                            style={{
                                fontWeight: 'bold',
                                color: CORES_PAINEL_VOTACAO.sucessoFundoEscuro
                            }}
                        >
                            1 voto
                        </span>
                    </Typography>
                    {placar.votosExplicitos > 0 ? (
                        <>
                            <Typography
                                variant="body2"
                                sx={{ color: 'rgba(255, 255, 255, 0.9)' }}
                            >
                                • Acompanham:{' '}
                                <span
                                    style={{
                                        fontWeight: 'bold',
                                        color: CORES_PAINEL_VOTACAO.sucessoFundoEscuro
                                    }}
                                >
                                    {placar.votosExplicitos} voto
                                    {Number.isInteger(placar.votosExplicitos) && placar.votosExplicitos > 1 ? 's' : ''}
                                </span>
                            </Typography>
                            <Box sx={{ ml: 2, mt: 0.5 }}>
                                {placar.detalhesVotos.map((sigla, index) => (
                                    <Typography
                                        key={`${sigla}-${index}`}
                                        variant="caption"
                                        sx={{
                                            display: 'block',
                                            color: 'rgba(255, 255, 255, 0.7)'
                                        }}
                                    >
                                        - {sigla}
                                    </Typography>
                                ))}
                            </Box>
                        </>
                    ) : (
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'rgba(255, 255, 255, 0.5)',
                                fontStyle: 'italic'
                            }}
                        >
                            • Nenhum magistrado acompanhou ainda
                        </Typography>
                    )}
                </Box>

                <Box
                    sx={{
                        mt: 2,
                        pt: 1,
                        borderTop: '1px solid rgba(255, 255, 255, 0.2)'
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 'bold',
                            color: '#ffffff'
                        }}
                    >
                        Total:{' '}
                        <span
                            style={{
                                color: CORES_PAINEL_VOTACAO.infoFundoEscuro,
                                fontSize: '1.1em'
                            }}
                        >
                            {placar.total} voto{placar.total > 1 ? 's' : ''}
                        </span>
                    </Typography>
                </Box>
            </Box>
        );

        return (
            <Tooltip
                title={renderDetalhesTooltip()}
                arrow
                placement="right"
                enterDelay={300}
                slotProps={{
                    tooltip: {
                        sx: {
                            backgroundColor: CORES_PAINEL_VOTACAO.tooltipFundo,
                            color: CORES_PAINEL_VOTACAO.tooltipTexto,
                            backdropFilter: 'blur(4px)',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
                            '& .MuiTooltip-arrow': {
                                color: CORES_PAINEL_VOTACAO.tooltipFundo
                            }
                        }
                    }
                }}
            >
                <Typography
                    variant="caption"
                    sx={{
                        display: 'inline-block',
                        fontWeight: 'bold',
                        color: CORES_PAINEL_VOTACAO.info,
                        cursor: 'help',
                        ml: 1,
                        '&:hover': {
                            textDecoration: 'underline',
                            opacity: 0.8
                        }
                    }}
                >
                    📊 {placar.total}
                </Typography>
            </Tooltip>
        );
    };

    renderPlacarMateria = (materia) => {
        const siglaRelator = this.observableProps.registro.processo.relator.sigla;
        const placar = PlacarVotacaoService.contabilizarPlacarMateria(materia, siglaRelator);

        if (!placar || placar.placarTodasDeliberacoes.length === 0) {
            return null;
        }

        const renderDetalhesTooltip = () => {
            // Calcula posições corretas considerando empates
            const deliberacoesComPosicoes = PlacarVotacaoService.calcularPosicoesComEmpates(
                placar.placarTodasDeliberacoes
            );

            return (
                <Box sx={{ p: 1, maxWidth: 350 }}>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            fontWeight: 'bold',
                            mb: 1,
                            color: '#ffffff'
                        }}
                    >
                        Placar Completo do Materia
                    </Typography>

                    {/* Status do relator se existir */}
                    {!!(placar.temDeliberacaoRelator && placar.relatorStatus) && (
                        <Box
                            sx={{
                                mb: 2,
                                p: 1,
                                borderRadius: 1,
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                borderLeft: `4px solid ${this.getCorStatusRelatorFundoEscuro(placar.relatorStatus.tipo)}`
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: 'bold',
                                    color: '#ffffff'
                                }}
                            >
                                Relator ({this.observableProps.registro.processo.relator.sigla}):
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    ml: 1,
                                    color: 'rgba(255, 255, 255, 0.9)'
                                }}
                            >
                                {placar.deliberacaoRelator.descricao || 'Sem descrição'}
                            </Typography>

                            <Box sx={{ mt: 1 }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: 'bold',
                                        color: this.getCorStatusRelatorFundoEscuro(placar.relatorStatus.tipo)
                                    }}
                                >
                                    {this.getIconeStatusRelator(placar.relatorStatus.tipo)}
                                    {placar.relatorStatus.texto}
                                </Typography>
                            </Box>
                        </Box>
                    )}

                    {/* Lista completa das deliberações ordenadas */}
                    <Box sx={{ mb: 1 }}>
                        {deliberacoesComPosicoes.map((p) => {
                            const corPosicao = this.getCorPorPosicao(p.posicao);
                            const isRelator = p.ehDoRelator;
                            const isPrimeiro = p.posicao === 1;

                            return (
                                <Box
                                    key={p.deliberacaoId}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        mb: 0.5,
                                        p: 0.5,
                                        backgroundColor: isRelator
                                            ? 'rgba(33, 150, 243, 0.15)' // Azul mais claro
                                            : isPrimeiro
                                              ? 'rgba(76, 175, 80, 0.15)' // Verde mais claro
                                              : 'rgba(255, 255, 255, 0.05)',
                                        borderRadius: 1,
                                        border: isRelator
                                            ? `1px solid ${CORES_PAINEL_VOTACAO.bordaRelator}`
                                            : '1px solid rgba(255, 255, 255, 0.1)',
                                        borderLeft: p.temEmpate
                                            ? `4px solid ${CORES_PAINEL_VOTACAO.relatorEmpatadoFundoEscuro}`
                                            : undefined
                                    }}
                                >
                                    <Box sx={{ flex: 1 }}>
                                        <Typography
                                            variant="body2"
                                            sx={{ color: '#ffffff' }}
                                        >
                                            <span
                                                style={{
                                                    fontWeight: 'bold',
                                                    marginRight: 8,
                                                    color: corPosicao
                                                }}
                                            >
                                                {p.posicao}º{!!p.temEmpate && ' ⚖️'}
                                            </span>
                                            {!!isRelator && (
                                                <span
                                                    style={{
                                                        color: CORES_PAINEL_VOTACAO.destaqueRelator,
                                                        marginRight: 4,
                                                        fontSize: '0.9em'
                                                    }}
                                                >
                                                    ✍️
                                                </span>
                                            )}
                                            {p.descricao?.slice(0, 30) || 'Sem descrição'}
                                            {p.descricao?.length > 30 && '...'}
                                        </Typography>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                color: 'rgba(255, 255, 255, 0.7)',
                                                display: 'block'
                                            }}
                                        >
                                            {p.magistradoResponsavel}
                                            {!!p.autorIncluido && ' (inclui autor da deliberação)'}
                                        </Typography>
                                    </Box>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontWeight: 'bold',
                                            minWidth: '40px',
                                            textAlign: 'right',
                                            color: isRelator ? CORES_PAINEL_VOTACAO.destaqueRelator : corPosicao
                                        }}
                                    >
                                        {p.total}
                                    </Typography>
                                </Box>
                            );
                        })}
                    </Box>
                    {placar.empates.length > 0 && (
                        <Box
                            sx={{
                                mt: 1,
                                pt: 1,
                                borderTop: '1px solid rgba(255, 255, 255, 0.2)'
                            }}
                        >
                            <Typography
                                variant="caption"
                                sx={{
                                    fontWeight: 'bold',
                                    display: 'block',
                                    mb: 0.5,
                                    color: CORES_PAINEL_VOTACAO.relatorEmpatadoFundoEscuro
                                }}
                            >
                                Empates Detectados:
                            </Typography>
                            {placar.empates.map((empate, index) => (
                                <Typography
                                    key={index}
                                    variant="caption"
                                    sx={{
                                        display: 'block',
                                        color: CORES_PAINEL_VOTACAO.relatorEmpatadoFundoEscuro
                                    }}
                                >
                                    • {PlacarVotacaoService.getDescricaoEmpate(empate)}
                                </Typography>
                            ))}
                        </Box>
                    )}
                </Box>
            );
        };

        // Cor e ícone para exibição principal (fora do tooltip)
        const getStatusInfo = () => {
            if (!placar.temDeliberacaoRelator) {
                return {
                    cor: CORES_PAINEL_VOTACAO.neutro,
                    icone: '📊',
                    texto: ''
                };
            }

            switch (placar.relatorStatus?.tipo) {
                case 'VENCENDO':
                    return {
                        cor: CORES_PAINEL_VOTACAO.relatorVencendo,
                        icone: '🏆',
                        texto: 'Relator vencendo'
                    };
                case 'EMPATE_PRIMEIRO':
                    return {
                        cor: CORES_PAINEL_VOTACAO.relatorEmpatado,
                        icone: '⚖️',
                        texto: 'Empate'
                    };
                case 'PERDENDO':
                    return {
                        cor: CORES_PAINEL_VOTACAO.relatorPerdendo,
                        icone: '🥊',
                        texto: `Relator sendo vencido` // - ${placar.posicaoRelator}º`
                    };
                default:
                    return {
                        cor: CORES_PAINEL_VOTACAO.neutro,
                        icone: '📊',
                        texto: ''
                    };
            }
        };

        const status = getStatusInfo();

        return (
            <Tooltip
                title={renderDetalhesTooltip()}
                arrow
                placement="right"
                enterDelay={500}
                slotProps={{
                    tooltip: {
                        sx: {
                            backgroundColor: CORES_PAINEL_VOTACAO.tooltipFundo,
                            color: CORES_PAINEL_VOTACAO.tooltipTexto,
                            backdropFilter: 'blur(4px)',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
                            '& .MuiTooltip-arrow': {
                                color: CORES_PAINEL_VOTACAO.tooltipFundo
                            }
                        }
                    }
                }}
            >
                <Typography
                    variant="caption"
                    sx={{
                        display: 'block',
                        mt: 1,
                        fontWeight: 'bold',
                        color: status.cor,
                        cursor: 'help',
                        '&:hover': {
                            textDecoration: 'underline',
                            opacity: 0.8
                        }
                    }}
                >
                    {status.icone} Placar: {placar.resumoPlacar}
                    {status.texto && ` (${status.texto})`}
                </Typography>
            </Tooltip>
        );
    };

    getCorStatusRelatorFundoEscuro(tipo) {
        switch (tipo) {
            case 'VENCENDO':
                return CORES_PAINEL_VOTACAO.relatorVencendoFundoEscuro;
            case 'EMPATE_PRIMEIRO':
                return CORES_PAINEL_VOTACAO.relatorEmpatadoFundoEscuro;
            case 'PERDENDO':
                return CORES_PAINEL_VOTACAO.relatorPerdendoFundoEscuro;
            default:
                return CORES_PAINEL_VOTACAO.neutroFundoEscuro;
        }
    }

    getIconeStatusRelator(tipo) {
        switch (tipo) {
            case 'VENCENDO':
                return '🏆 ';
            case 'EMPATE_PRIMEIRO':
                return '⚖️ ';
            case 'PERDENDO':
                return '🥊 ';
            default:
                return '';
        }
    }

    getCorPorPosicao(posicao) {
        if (posicao === 1) {
            return CORES_PAINEL_VOTACAO.primeiroLugar;
        }
        return CORES_PAINEL_VOTACAO.outrosLugares;
    }

    getCorFundoDeliberacao = (isVencedora, isEmpatada) => {
        if (isVencedora) {
            return CORES_PAINEL_VOTACAO.destaqueVencedor;
        }

        if (isEmpatada) {
            return CORES_PAINEL_VOTACAO.destaqueEmpate;
        }

        return 'inherit';
    };

    calcularPlacarDeliberacao = (deliberacao) => {
        return PlacarVotacaoService.calcularPlacarDeliberacao(deliberacao);
    };

    get renderTituloDialog() {
        return (
            <Stack direction="row">
                <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-start' }}>
                    <Typography
                        display="inline"
                        sx={{ fontWeight: 'bold' }}
                    >
                        Controle de votação em sessão ao vivo
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end' }}>
                    <Typography
                        display="inline"
                        sx={{ fontWeight: 'bold' }}
                    >
                        {this.observableProps.registro.processo.numeroCompleto}
                    </Typography>
                    <RelatorChip
                        relator={this.observableProps.registro.processo.relator}
                        composicao={this.observableProps.registro.composicao}
                        exibirFoto={true}
                        sx={{ ml: 1 }}
                    />
                </Box>
            </Stack>
        );
    }

    renderCelulaVoto(mag) {
        const voto = mag.voto;

        if (voto && voto.situacaoVoto !== SITUACAO_VOTO.SEM_VOTO.id) {
            const cor =
                voto.situacaoVoto === SITUACAO_VOTO.PRE_VOTADO.id
                    ? SITUACAO_VOTO.SEM_VOTO.cor
                    : TipoVoto.getCorByCodigo(voto.voto.codigo);

            return (
                <Tooltip title={SituacaoVoto.getDescricao(voto.situacaoVoto)}>
                    <HowToVoteIcon sx={{ color: cor }} />
                </Tooltip>
            );
        }

        if (mag.relator) {
            return <EditNoteIcon />;
        }

        if (mag.ausente) {
            return <LocationOffIcon sx={{ color: SITUACAO_VOTO.SEM_VOTO.cor }} />;
        }

        if (mag.impedido || mag.possivelmenteImpedido) {
            const cor = mag.impedido
                ? SITUACAO_IMPEDIMENTOS_PROCESSO.IMPEDIMENTO_DECLARADO_NA_COMPOSICAO.cor
                : SITUACAO_IMPEDIMENTOS_PROCESSO.POSSIVEL_IMPEDIMENTO_NA_COMPOSICAO.cor;

            return mag.impedido ? (
                <PanToolIcon sx={{ color: cor }} />
            ) : (
                <ThumbDownIcon sx={{ color: cor, transform: 'scaleX(-1)' }} />
            );
        }

        return <CloseIcon sx={{ color: SITUACAO_VOTO.SEM_VOTO.cor }} />;
    }

    mostrarDicasEdicaoMateria = () => {
        this.mensagemStore.abrirMensagemInfo(
            '💡 Dica: Você pode editar a matéria clicando no texto ou usando o menu (⋮). Pressione Enter para salvar ou Esc para cancelar.'
        );
    };

    get renderTabelaControleVotacao() {
        if (!this.composicaoComVotos) {
            return null;
        }

        return (
            <Box sx={{ height: '100%', p: 1 }}>
                {EXIBIR_MENU_ACIMA_TABELA && this.renderMenuTabela}
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell width="25%">
                                    <Typography fontWeight="bold">Matéria</Typography>
                                    <Typography
                                        variant="caption"
                                        sx={{ color: 'text.secondary', fontStyle: 'italic' }}
                                    >
                                        (Ex: Matéria preliminar)
                                    </Typography>
                                </TableCell>
                                <TableCell width="25%">
                                    <Typography fontWeight="bold">Deliberação</Typography>
                                    <Typography
                                        variant="caption"
                                        sx={{ color: 'text.secondary', fontStyle: 'italic' }}
                                    >
                                        Sentido do voto. (Ex: Dar provimento.)
                                    </Typography>
                                </TableCell>
                                <TableCell
                                    width="5%"
                                    align="center"
                                    sx={{ padding: '4px !important' }}
                                >
                                    <Tooltip title={<Typography>Placar da deliberação</Typography>}>
                                        <Typography fontWeight="bold">📊</Typography>
                                    </Tooltip>
                                </TableCell>
                                {this.composicaoComVotos.map((mag) => (
                                    <TableCell
                                        key={mag.siglaDoMagistrado}
                                        align="center"
                                        sx={{ padding: '4px !important' }}
                                    >
                                        {EXIBIR_AVATAR_MAGISTRADO_TITULO_TABELA
                                            ? this.renderAvatarMagistradoTituloTabela(mag.siglaDoMagistrado)
                                            : this.renderMagistradoTituloTabela(mag.siglaDoMagistrado)}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {this.materias.map((materia) =>
                                materia.deliberacoes?.map((deliberacao, indexDeliberacao) =>
                                    (() => {
                                        const deliberacaoVencedora =
                                            PlacarVotacaoService.obterDeliberacaoVencedora(materia);
                                        const deliberacoesEmpatadas =
                                            PlacarVotacaoService.obterDeliberacoesEmpatadas(materia);
                                        const isVencedora = deliberacaoVencedora?.id === deliberacao.id;
                                        const isEmpatada = deliberacoesEmpatadas.some((o) => o.id === deliberacao.id);

                                        return (
                                            <TableRow
                                                key={`${materia.id}-${deliberacao.id}`}
                                                hover
                                                sx={{
                                                    backgroundColor: this.getCorFundoDeliberacao(
                                                        isVencedora,
                                                        isEmpatada
                                                    )
                                                }}
                                            >
                                                {/* Matéria (mescla as linhas verticalmente) */}
                                                {indexDeliberacao === 0 && (
                                                    <TableCell
                                                        rowSpan={materia.deliberacoes.length}
                                                        sx={{
                                                            verticalAlign: 'top',
                                                            backgroundColor: '#fafafa',
                                                            position: 'relative' // Para posicionar o indicador de edição
                                                        }}
                                                    >
                                                        {/* Indicador visual quando está em edição */}
                                                        {this.materiaEmEdicaoId === materia.id && (
                                                            <Box
                                                                sx={{
                                                                    position: 'absolute',
                                                                    top: 0,
                                                                    left: 0,
                                                                    right: 0,
                                                                    height: '3px',
                                                                    backgroundColor: blue[500],
                                                                    borderTopLeftRadius: '4px',
                                                                    borderTopRightRadius: '4px'
                                                                }}
                                                            />
                                                        )}

                                                        <Stack
                                                            direction={'row'}
                                                            alignItems="flex-start"
                                                        >
                                                            <IconButton
                                                                size="small"
                                                                onClick={(e) => this.abrirMenuMateria(e, materia)}
                                                                sx={{ mt: 0.5 }}
                                                            >
                                                                <MoreVertIcon fontSize="small" />
                                                            </IconButton>

                                                            <Box sx={{ flexGrow: 1, ml: 1 }}>
                                                                {this.materiaEmEdicaoId === materia.id ? (
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        defaultValue={materia.descricao}
                                                                        inputRef={this.materiaInputRef}
                                                                        id={`materia-edicao-${materia.id}`}
                                                                        name={`materia-${materia.id}`}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Escape') {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                this.cancelarEdicaoMateria();
                                                                            }

                                                                            if (e.key === 'Enter') {
                                                                                e.preventDefault();
                                                                                this.finalizarEdicaoMateria(
                                                                                    materia.id,
                                                                                    this.materiaInputRef.current.value
                                                                                );
                                                                            }
                                                                        }}
                                                                        onBlur={() =>
                                                                            this.finalizarEdicaoMateria(
                                                                                materia.id,
                                                                                this.materiaInputRef.current.value
                                                                            )
                                                                        }
                                                                        slotProps={{
                                                                            input: {
                                                                                endAdornment: (
                                                                                    <IconButton
                                                                                        size="small"
                                                                                        onClick={
                                                                                            this.cancelarEdicaoMateria
                                                                                        }
                                                                                    >
                                                                                        <CloseIcon fontSize="small" />
                                                                                    </IconButton>
                                                                                )
                                                                            }
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <Typography
                                                                        fontWeight="bold"
                                                                        sx={{
                                                                            cursor: 'text',
                                                                            py: 0.5,
                                                                            px: 0.5,
                                                                            borderRadius: 1,
                                                                            '&:hover': {
                                                                                backgroundColor:
                                                                                    'rgba(25, 118, 210, 0.04)',
                                                                                textDecoration: 'underline',
                                                                                color: blue[600]
                                                                            }
                                                                        }}
                                                                        onDoubleClick={() =>
                                                                            this.entrarEmEdicaoMateria(materia)
                                                                        }
                                                                    >
                                                                        {materia.descricao}
                                                                    </Typography>
                                                                )}

                                                                <Stack
                                                                    direction={'column'}
                                                                    alignItems={'flex-start'}
                                                                    sx={{ mt: 1 }}
                                                                >
                                                                    <Typography
                                                                        variant="caption"
                                                                        sx={{
                                                                            color: 'text.secondary',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: 0.5,
                                                                            ml: 0.5
                                                                        }}
                                                                    >
                                                                        {materia.deliberacoes.length} deliberação(ões)
                                                                    </Typography>

                                                                    {this.materiaEmEdicaoId !== materia.id && (
                                                                        <Button
                                                                            size="small"
                                                                            variant="outlined"
                                                                            startIcon={<AddIcon />}
                                                                            onClick={() =>
                                                                                this.abrirModalAdicionarDeliberacao(
                                                                                    materia
                                                                                )
                                                                            }
                                                                            sx={{
                                                                                textTransform: 'none',
                                                                                mt: 0.5,
                                                                                fontSize: '0.75rem'
                                                                            }}
                                                                        >
                                                                            deliberação
                                                                        </Button>
                                                                    )}
                                                                </Stack>
                                                            </Box>
                                                        </Stack>

                                                        {this.renderPlacarMateria(materia)}
                                                    </TableCell>
                                                )}
                                                {/* Deliberação */}
                                                <TableCell>
                                                    {this.deliberacaoEmEdicaoId === deliberacao.id && (
                                                        <Box
                                                            sx={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                right: 0,
                                                                height: '3px',
                                                                backgroundColor: blue[500],
                                                                borderTopLeftRadius: '4px',
                                                                borderTopRightRadius: '4px'
                                                            }}
                                                        />
                                                    )}
                                                    {this.deliberacaoEmEdicaoId === deliberacao.id ? (
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            defaultValue={deliberacao.descricao}
                                                            inputRef={this.deliberacaoInputRef}
                                                            id={`deliberacao-edicao-${deliberacao.id}`}
                                                            name={`deliberacao-${deliberacao.id}`}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Escape') {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.cancelarEdicaoDeliberacao();
                                                                }

                                                                if (e.key === 'Enter') {
                                                                    e.preventDefault();
                                                                    this.finalizarEdicaoDeliberacao(
                                                                        materia.id,
                                                                        deliberacao.id,
                                                                        this.deliberacaoInputRef.current.value
                                                                    );
                                                                }
                                                            }}
                                                            onBlur={() =>
                                                                this.finalizarEdicaoDeliberacao(
                                                                    materia.id,
                                                                    deliberacao.id,
                                                                    this.deliberacaoInputRef.current.value
                                                                )
                                                            }
                                                            slotProps={{
                                                                input: {
                                                                    endAdornment: (
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={this.cancelarEdicaoDeliberacao}
                                                                        >
                                                                            <CloseIcon fontSize="small" />
                                                                        </IconButton>
                                                                    )
                                                                }
                                                            }}
                                                            sx={{
                                                                '& .MuiOutlinedInput-root': {
                                                                    backgroundColor: 'white',
                                                                    boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)'
                                                                }
                                                            }}
                                                        />
                                                    ) : (
                                                        <Typography
                                                            fontWeight="bold"
                                                            sx={{
                                                                cursor: 'text',
                                                                py: 0.5,
                                                                px: 1,
                                                                borderRadius: 1,
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                                                    textDecoration: 'underline',
                                                                    color: blue[600]
                                                                }
                                                            }}
                                                            onDoubleClick={() =>
                                                                this.entrarEmEdicaoDeliberacao(materia, deliberacao)
                                                            }
                                                        >
                                                            {deliberacao.descricao}
                                                        </Typography>
                                                    )}
                                                    {this.isDeveExibirMenuRelator(deliberacao) ? (
                                                        <IconButton
                                                            size="small"
                                                            onClick={(e) =>
                                                                this.abrirMenuDeliberacao(e, materia, deliberacao)
                                                            }
                                                        >
                                                            <MoreVertIcon fontSize="small" />
                                                        </IconButton>
                                                    ) : (
                                                        <Tooltip title={<Typography>Relator</Typography>}>
                                                            <Typography
                                                                display={'inline'}
                                                                sx={{ mr: 1 }}
                                                            >
                                                                ✍️
                                                            </Typography>
                                                        </Tooltip>
                                                    )}
                                                    {this.responsavelEmEdicaoId === deliberacao.id ? (
                                                        this.renderAlteracaoResponsavel(materia, deliberacao)
                                                    ) : (
                                                        <Typography
                                                            display={'inline'}
                                                            variant="caption"
                                                            sx={{
                                                                color: 'text.secondary',
                                                                cursor: this.isDeveExibirMenuRelator(deliberacao)
                                                                    ? 'pointer'
                                                                    : 'text',
                                                                py: 0.5,
                                                                px: 1,
                                                                borderRadius: 1,
                                                                '&:hover': this.isDeveExibirMenuRelator(deliberacao)
                                                                    ? {
                                                                          backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                                                          textDecoration: 'underline',
                                                                          color: blue[600]
                                                                      }
                                                                    : {}
                                                            }}
                                                            onDoubleClick={(e) => {
                                                                e.stopPropagation();

                                                                if (this.isDeveExibirMenuRelator(deliberacao)) {
                                                                    this.iniciarEdicaoResponsavel(deliberacao.id);
                                                                }
                                                            }}
                                                        >
                                                            <b>Autor</b>: {deliberacao.magistradoResponsavel || '—'}
                                                        </Typography>
                                                    )}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    sx={{
                                                        padding: '4px !important',
                                                        verticalAlign: 'middle'
                                                    }}
                                                >
                                                    {this.renderPlacarDeliberacao(deliberacao)}
                                                </TableCell>
                                                {this.composicaoComVotos.map((mag) => {
                                                    const voto = deliberacao.votos.find(
                                                        (v) => v.magistradoResponsavel === mag.siglaDoMagistrado
                                                    );

                                                    const isAutor =
                                                        mag.siglaDoMagistrado === deliberacao.magistradoResponsavel;

                                                    return (
                                                        <TableCell
                                                            key={`${materia.id}-${deliberacao.id}-${mag.siglaDoMagistrado}`}
                                                            align="center"
                                                            sx={{
                                                                cursor: isAutor ? 'default' : 'pointer',
                                                                padding: '4px !important',
                                                                verticalAlign: 'middle'
                                                            }}
                                                            onClick={(e) => {
                                                                if (isAutor) return undefined;

                                                                this.abrirMenuVoto(
                                                                    e,
                                                                    materia,
                                                                    deliberacao,
                                                                    mag.siglaDoMagistrado
                                                                );
                                                            }}
                                                        >
                                                            {this.renderIconeVotoDeliberacao(voto, isAutor)}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })()
                                )
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box sx={{ mt: 2 }}>{this.renderMenuTabela}</Box>
                {!!this.openDialogAdicionarDeliberacao && this.renderDialogAdicionarDeliberacao}
            </Box>
        );
    }

    handleAlteraObservacaoRelator = (e) => {
        this.observacaoRelator = e.target.value;
    };

    handleAlteraObservacaoDivergencias = (e) => {
        this.observacaoDivergencias = e.target.value;
    };

    salvarObservacoes = async () => {
        const observacaoRelatorAtual = this.observacaoRelator || '';
        const observacaoDivergenciasAtual = this.observacaoDivergencias || '';
        const observacaoRelatorAnterior = this.observacaoRelatorSalva || '';
        const observacaoDivergenciasAnterior = this.observacaoDivergenciasSalva || '';
        const alterouRelator = observacaoRelatorAtual !== observacaoRelatorAnterior;
        const alterouDivergencias = observacaoDivergenciasAtual !== observacaoDivergenciasAnterior;

        if (!alterouRelator && !alterouDivergencias) {
            return;
        }

        try {
            const { sessaoId, processo } = this.observableProps.registro;
            const observacoes = [];

            if (observacaoRelatorAtual) {
                observacoes.push({
                    tipo: { id: 'R' },
                    descricao: observacaoRelatorAtual
                });
            }

            if (observacaoDivergenciasAtual) {
                observacoes.push({
                    tipo: { id: 'D' },
                    descricao: observacaoDivergenciasAtual
                });
            }

            await this.sessaoService.salvarObservacoes(sessaoId, processo.numeroCompleto, { observacoes });
            this.observacaoRelatorSalva = observacaoRelatorAtual;
            this.observacaoDivergenciasSalva = observacaoDivergenciasAtual;

            if (alterouRelator && alterouDivergencias) {
                this.mensagemStore.abrirMensagemSucesso(
                    'Observações do(a) relator(a) e de divergências atualizadas com sucesso.'
                );
            } else if (alterouRelator) {
                this.mensagemStore.abrirMensagemSucesso('Observação do(a) relator(a) atualizada com sucesso.');
            } else {
                this.mensagemStore.abrirMensagemSucesso('Observação de divergências atualizada com sucesso.');
            }
        } catch (err) {
            console.error(err);
            this.mensagemStore.abrirMensagemErro('Erro ao salvar observações. Tente novamente.');
        }
    };

    get renderObservacoes() {
        return (
            <Box sx={{ height: '100%', p: 1 }}>
                <Typography
                    display={'inline'}
                    fontWeight={'bold'}
                    sx={{ mb: 1 }}
                >
                    Observação do(a) relator(a)
                </Typography>
                <TextField
                    label="Observação do(a) relator(a)"
                    variant="filled"
                    multiline
                    minRows={8}
                    fullWidth
                    onChange={this.handleAlteraObservacaoRelator}
                    value={this.observacaoRelator}
                    slotProps={{
                        inputLabel: {
                            shrink: true
                        }
                    }}
                    sx={{ minWidth: '400px', mt: 1, mb: 2 }}
                    onBlur={() => {
                        this.salvarObservacoes();
                    }}
                />
                <Typography
                    display={'inline'}
                    fontWeight={'bold'}
                >
                    Observação de divergências
                </Typography>
                <TextField
                    label="Observação de divergências"
                    variant="filled"
                    multiline
                    minRows={8}
                    fullWidth
                    onChange={this.handleAlteraObservacaoDivergencias}
                    value={this.observacaoDivergencias}
                    slotProps={{
                        inputLabel: {
                            shrink: true
                        }
                    }}
                    sx={{ minWidth: '400px', mt: 1 }}
                    onBlur={() => {
                        this.salvarObservacoes();
                    }}
                />
            </Box>
        );
    }

    get renderProcesso() {
        return (
            <Box sx={{ height: '100%', p: 1 }}>
                <InformacoesProcesso
                    registro={this.observableProps.registro}
                    expandido
                />
            </Box>
        );
    }

    get renderSessoesAnteriores() {
        return (
            <Box sx={{ height: '100%', p: 1 }}>
                <DetalheSessaoAnterior registro={this.observableProps.registro} />
            </Box>
        );
    }

    get renderCertidao() {
        return (
            <Box sx={{ height: '100%', pt: 1 }}>
                <ComparacaoDecisaoRascunhoCertidao registro={this.observableProps.registro} />
                <RascunhoCertidaoComCarregamento registro={this.observableProps.registro} />
            </Box>
        );
    }

    get existePosicionamento() {
        const registro = this.observableProps.registro;
        const temRessalva = registro.votos?.some(
            (v) =>
                v.voto?.codigo === Dominios.CODIGO_VOTO_RESSALVA &&
                (v.situacaoVoto === 'CONFIRMADO' || v.situacaoVoto === 'PRE_VOTADO')
        );
        const temDivergencia = registro.votos?.some(
            (v) =>
                v.voto?.codigo === Dominios.CODIGO_VOTO_DIVERGENTE &&
                (v.situacaoVoto === 'CONFIRMADO' || v.situacaoVoto === 'PRE_VOTADO')
        );
        const temDestaque = registro.contabilizacoesObservacao?.some(
            (o) => o.tipoObservacao === 'DESTAQUE' && o.visibilidade === 'PUBLICA'
        );
        const temRetornoVista = registro.informacoesAdicionais?.RetornoVistaRegimental?.length > 0;
        return temRessalva || temDivergencia || temDestaque || temRetornoVista;
    }

    get renderPosicionamentos() {
        return (
            <Box sx={{ height: '100%', p: 1 }}>
                <PainelPosicionamentos registro={this.observableProps.registro} />
            </Box>
        );
    }

    renderAlteracaoResponsavel = (materia, deliberacao) => {
        const magistradosJaResponsaveisPorDeliberacoes = materia.deliberacoes.map(
            (deliberacao) => deliberacao.magistradoResponsavel
        );

        return (
            <TextField
                select
                size="small"
                autoFocus
                fullWidth
                value={deliberacao.magistradoResponsavel || ''}
                id={`autor-deliberacao-edicao-${deliberacao.id}`}
                name={`autor-deliberacao-${deliberacao.id}`}
                onChange={(e) => {
                    deliberacao.magistradoResponsavel = e.target.value;
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                        e.preventDefault();
                        e.stopPropagation();
                        this.responsavelEmEdicaoId = null;
                    }
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        e.stopPropagation();
                        this.finalizarEdicaoResponsavel(deliberacao, deliberacao.magistradoResponsavel);
                    }
                }}
                onBlur={(e) => {
                    // Só finaliza se o blur não foi causado por clicar em uma opção do menu
                    if (!e.relatedTarget || !e.relatedTarget.closest('[role="option"]')) {
                        this.finalizarEdicaoResponsavel(deliberacao, deliberacao.magistradoResponsavel);
                    }
                }}
                slotProps={{
                    select: {
                        onKeyDown: (e) => {
                            if (e.key === 'Escape') {
                                e.stopPropagation();
                            }
                        }
                    }
                }}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: 'white',
                        boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)'
                    }
                }}
            >
                {this.composicaoComVotos.map((mag) => (
                    <MenuItem
                        key={mag.siglaDoMagistrado}
                        value={mag.siglaDoMagistrado}
                        onClick={(e) => {
                            e.stopPropagation();
                            this.finalizarEdicaoResponsavel(deliberacao, mag.siglaDoMagistrado);
                        }}
                        disabled={magistradosJaResponsaveisPorDeliberacoes.includes(mag.siglaDoMagistrado)}
                    >
                        {mag.siglaDoMagistrado} — {mag.nome}
                    </MenuItem>
                ))}
            </TextField>
        );
    };

    alterarMagistradoResponsavelParaIncluirDeliberacao = (siglaMagistrado) => {
        this.magistradoResponsavelParaIncluirDeliberacao = siglaMagistrado;
    };

    handleAlteraDescricaoInclusaoDeliberacao = (e) => {
        this.descricaoInclusaoDeliberacao = e.target.value;
    };

    get renderDialogAdicionarDeliberacao() {
        const magistradosJaResponsaveisPorDeliberacoes = this.materiaParaIncluirDeliberacao.deliberacoes.map(
            (deliberacao) => deliberacao.magistradoResponsavel
        );
        return (
            <ModalConfirmacao
                open={!!this.openDialogAdicionarDeliberacao}
                titulo="Inclusão de deliberação"
                tipoConfirmacao={TIPO_CONFIRMACAO.INCLUSAO}
                callbackCancelar={() => this.fecharModalAdicionarDeliberacao()}
                callbackConfirmar={() => this.adicionarDeliberacao()}
                textoBotaoConfirmacao="Incluir"
                textoBotaoCancelamento="Cancelar"
            >
                <Typography
                    display={'inline'}
                    fontWeight={'bold'}
                >
                    Magistrado
                </Typography>
                <TextField
                    select
                    size="small"
                    autoFocus
                    fullWidth
                    value={this.magistradoResponsavelParaIncluirDeliberacao || ''}
                    onChange={(e) => {
                        this.alterarMagistradoResponsavelParaIncluirDeliberacao(e.target.value);
                    }}
                    slotProps={{
                        select: {
                            onKeyDown: (e) => {
                                if (e.key === 'Escape') {
                                    e.stopPropagation();
                                }
                            }
                        }
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            backgroundColor: 'white',
                            boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)'
                        },
                        marginBottom: 2
                    }}
                >
                    {this.composicaoComVotos.map((mag) => {
                        return (
                            <MenuItem
                                key={mag.siglaDoMagistrado}
                                value={mag.siglaDoMagistrado}
                                disabled={magistradosJaResponsaveisPorDeliberacoes.includes(mag.siglaDoMagistrado)}
                            >
                                {mag.siglaDoMagistrado} — {mag.nome}
                            </MenuItem>
                        );
                    })}
                </TextField>
                <Typography
                    display={'inline'}
                    fontWeight={'bold'}
                >
                    Descrição
                </Typography>
                <TextField
                    label="Descrição"
                    variant="filled"
                    multiline
                    minRows={4}
                    fullWidth
                    onChange={this.handleAlteraDescricaoInclusaoDeliberacao}
                    value={this.descricaoInclusaoDeliberacao}
                    slotProps={{
                        inputLabel: {
                            shrink: true
                        }
                    }}
                    sx={{ minWidth: '400px' }}
                />
            </ModalConfirmacao>
        );
    }

    get renderMenuTabela() {
        return (
            <Stack
                direction="row"
                justifyContent="flex-start"
            >
                <Box>
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={this.adicionarMateria}
                    >
                        Adicionar Matéria
                    </Button>
                </Box>
                <Box sx={{ ml: 2 }}>{this.renderBotoesPreenchimento}</Box>
                <Box sx={{ ml: 2 }}>
                    <VerificarInconsistenciasButton
                        variant="contained"
                        onVerificarInconsistencias={this.verificarInconsistencias}
                    />
                </Box>
            </Stack>
        );
    }

    /**
     * Verifica se o voto do autor (relator ou não) é válido
     */
    isVotoAutorValido = (voto, siglaAutor) => {
        if (!voto) return false;

        const isRelator = siglaAutor === this.observableProps.registro.processo.relator.sigla;
        return VotacaoService.isVotoValido(voto, siglaAutor, isRelator);
    };

    isDeveExibirMenuRelator(deliberacao) {
        return EXIBIR_MENU_DELIBERACAO_RELATOR || !this.isAutorDeliberacaoEhRelator(deliberacao.magistradoResponsavel);
    }

    /**
     * Obtém um objeto que contém a composição da processo com os votos.
     *
     * @returns {Array} Objeto que contém a composição da processo com os votos
     */
    get composicaoComVotos() {
        const composicaoComVotos = this.sessaoStore.montarComposicaoComVotos(this.observableProps.registro);
        const composicaoOrdenada = this.ordenarComRelatorPrimeiro(composicaoComVotos);
        return composicaoOrdenada;
    }

    ordenarComRelatorPrimeiro(composicao) {
        if (!composicao || composicao.length === 0) {
            return composicao;
        }

        // Encontrar o índice do relator
        const relatorIndex = composicao.findIndex(
            (item) => item.tipo === 'relator' || item.isRelator || item.relator === true
        );

        // Se não encontrar relator, retorna o array original
        if (relatorIndex === -1) return composicao;

        // Criar uma cópia do array
        const novaComposicao = [...composicao];

        // Remover o relator da posição atual e adicionar no início
        const [relator] = novaComposicao.splice(relatorIndex, 1);
        novaComposicao.unshift(relator);

        return novaComposicao;
    }

    /**
     * Obtém o objeto do magistrado da composição pela sua sigla.
     *
     * @param {string} sigla A sigla do magistrado
     * @returns {object | null} O objeto que representa um magistrado
     */
    getObjMagistradoComposicaoPelaSigla(sigla) {
        if (!this.observableProps.registro?.composicao) {
            return null;
        }

        return this.observableProps.registro.composicao.find(
            (/** @type {Object} */ comp) => comp.magistrado.sigla === sigla
        );
    }

    descricaoMagistrado(nomeMagistrado, siglaMagistrado, cadeiraMagistrado) {
        return (
            <>
                {!!nomeMagistrado && <Typography sx={{ mt: 0.5 }}>{nomeMagistrado}</Typography>}
                {!!siglaMagistrado && <Typography sx={{ mt: 0.5 }}>{siglaMagistrado}</Typography>}
                {!!cadeiraMagistrado && <Typography sx={{ mt: 0.5 }}>{`Cadeira: ${cadeiraMagistrado}`}</Typography>}
            </>
        );
    }

    getIdUrl(magistradoComposicao) {
        return !magistradoComposicao?.imagem?.url || magistradoComposicao.imagem.url.trim() === ''
            ? magistradoComposicao?.magistrado?.cpf
            : magistradoComposicao.imagem.url;
    }

    renderTooltipMagistrado(siglaMagistrado) {
        const magistradoComposicao = this.getObjMagistradoComposicaoPelaSigla(siglaMagistrado);
        const nomeMagistrado = magistradoComposicao?.magistrado?.nome;
        const cadeiraMagistrado = magistradoComposicao?.magistrado?.cadeira;

        const url = this.getIdUrl(magistradoComposicao);

        const contentTypePadrao = 'jpeg';
        let foto = null;

        if (url) {
            foto = this.fotoMagistradoStore.fotosDisponiveisEmMemoria.get(url);
        }

        if (!foto?.imgBase64) {
            return this.descricaoMagistrado(nomeMagistrado, siglaMagistrado, cadeiraMagistrado);
        }

        const srcFoto = `data:image/${foto.imgContentType || contentTypePadrao};base64,${foto.imgBase64}`;

        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    m: 0.5
                }}
            >
                <Avatar
                    sx={{ width: 120, height: 120 }}
                    src={srcFoto}
                />
                {this.descricaoMagistrado(nomeMagistrado, siglaMagistrado, cadeiraMagistrado)}
            </Box>
        );
    }

    isMagistradoRetornoVistaRegimental(siglaMagistrado) {
        const retornos = this.observableProps.registro?.informacoesAdicionais?.RetornoVistaRegimental;

        if (!Array.isArray(retornos)) {
            return false;
        }

        return retornos.some((r) => r.magistrado?.sigla === siglaMagistrado);
    }

    renderMagistradoTituloTabela(siglaMagistrado) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Tooltip title={this.renderTooltipMagistrado(siglaMagistrado)}>
                    <Typography fontWeight="bold">{siglaMagistrado}</Typography>
                </Tooltip>
                <Box
                    height={16}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    {this.isMagistradoRetornoVistaRegimental(siglaMagistrado) && (
                        <Tooltip title="Retorno de vista regimental">
                            <RemoveRedEyeIcon sx={{ fontSize: 16, color: grey[600], mt: 0.25 }} />
                        </Tooltip>
                    )}
                </Box>
            </Box>
        );
    }

    renderAvatarMagistradoTituloTabela(siglaMagistrado) {
        const magistradoComposicao = this.getObjMagistradoComposicaoPelaSigla(siglaMagistrado);
        const url = this.getIdUrl(magistradoComposicao);

        const contentTypePadrao = 'jpeg';
        let foto = null;

        if (url) {
            foto = this.fotoMagistradoStore.fotosDisponiveisEmMemoria.get(url);
        }

        if (!foto?.imgBase64) {
            return this.renderMagistradoTituloTabela(siglaMagistrado);
        }

        const isRelator = this.observableProps.registro?.processo?.relator?.sigla === siglaMagistrado;

        const srcFoto = `data:image/${foto.imgContentType || contentTypePadrao};base64,${foto.imgBase64}`;

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Tooltip title={this.renderTooltipMagistrado(siglaMagistrado)}>
                    <Avatar
                        sx={{
                            width: 32,
                            height: 32,
                            border: isRelator ? `2px solid ${CORES_PAINEL_VOTACAO.autorDeliberacaoRelator}` : 'none'
                        }}
                        src={srcFoto}
                    />
                </Tooltip>
                <Box
                    height={16}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    {this.isMagistradoRetornoVistaRegimental(siglaMagistrado) && (
                        <Tooltip title="Retorno de vista regimental">
                            <RemoveRedEyeIcon sx={{ fontSize: 16, color: grey[600], mt: 0.25 }} />
                        </Tooltip>
                    )}
                </Box>
            </Box>
        );
    }

    isAutorDeliberacaoSelecionadaEhRelator() {
        return !!(
            this.deliberacaoSelecionada?.magistradoResponsavel &&
            this.deliberacaoSelecionada?.magistradoResponsavel === this.observableProps.registro.processo.relator.sigla
        );
    }

    isAutorDeliberacaoEhRelator(siglaMagistradoAutorDeliberacaoVoto) {
        return !!(
            siglaMagistradoAutorDeliberacaoVoto &&
            siglaMagistradoAutorDeliberacaoVoto === this.observableProps.registro.processo.relator.sigla
        );
    }

    getCorVoto(voto) {
        if (!voto.situacaoVoto || voto.situacaoVoto === SITUACAO_VOTO.PRE_VOTADO.id) {
            return SITUACAO_VOTO.SEM_VOTO.cor;
        }

        return TipoVoto.getCorByCodigo(voto.voto.codigo);
    }

    render() {
        if (!this.isComponenteHabilitado('PainelControleVotacaoSessao')) {
            return null;
        }

        return (
            <>
                <IconButton
                    onClick={this.abrir}
                    sx={{ cursor: 'pointer' }}
                    size="small"
                >
                    <Tooltip title={<Typography>Controle de votação da sessão</Typography>}>
                        <FactCheckIcon
                            sx={{
                                color: 'black'
                            }}
                        />
                    </Tooltip>
                </IconButton>
                {!!this.aberto && (
                    <DialogPainelVotacaoSessao
                        open={this.aberto}
                        onClose={this.fechar}
                        maxWidth={'md'}
                        fullWidth
                    >
                        <DialogTitle sx={{ pt: 3, pl: 4, pr: 4 }}>{this.renderTituloDialog}</DialogTitle>
                        <DialogContent
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                flex: 1,
                                minHeight: ALTURA_MINIMA_DIALOG_CONTENT,
                                maxHeight: ALTURA_MAXIMA_DIALOG_CONTENT
                            }}
                        >
                            <Box
                                sx={{
                                    border: '1px solid rgba(0, 0, 0, 0.12)',
                                    p: 0.5,
                                    borderRadius: 3,
                                    mb: 1,
                                    ml: 0.5,
                                    mr: 0.5
                                }}
                            >
                                <ProcessoApregoado
                                    corDoTexto="black"
                                    semAcao
                                />
                            </Box>
                            <Tabs
                                todasTabsComMesmaAltura={true}
                                tabs={[
                                    {
                                        id: 1,
                                        titulo: 'Painel de votação',
                                        conteudo: this.renderTabelaControleVotacao
                                    },
                                    {
                                        id: 2,
                                        titulo: 'Observações',
                                        conteudo: this.renderObservacoes
                                    },
                                    ...(this.existePosicionamento
                                        ? [
                                              {
                                                  id: 6,
                                                  titulo: 'Posicionamentos de votação',
                                                  conteudo: this.renderPosicionamentos
                                              }
                                          ]
                                        : []),
                                    {
                                        id: 3,
                                        titulo: 'Processo',
                                        conteudo: this.renderProcesso
                                    },
                                    {
                                        id: 4,
                                        titulo: 'Sessões anteriores',
                                        conteudo: this.renderSessoesAnteriores
                                    },
                                    {
                                        id: 5,
                                        titulo: 'Certidão',
                                        conteudo: this.renderCertidao
                                    }
                                ]}
                            />
                        </DialogContent>
                        <DialogActions sx={{ mt: 2, ml: 3, mr: 3, mb: 2, justifyContent: 'space-between' }}>
                            <Box>
                                <AbrirDialogComposicaoButton
                                    registro={this.observableProps.registro}
                                    variant={'outlined'}
                                />
                            </Box>
                            <Box>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    endIcon={<CloseIcon />}
                                    onClick={this.fechar}
                                >
                                    Fechar
                                </Button>
                            </Box>
                        </DialogActions>
                        {this.renderMenuVotos()}
                        {(!!EXIBIR_MENU_DELIBERACAO_RELATOR || !this.isAutorDeliberacaoSelecionadaEhRelator()) && (
                            <Menu
                                anchorEl={this.menuDeliberacaoAnchor}
                                open={Boolean(this.menuDeliberacaoAnchor)}
                                onClose={this.fecharMenuDeliberacao}
                            >
                                <MenuItem
                                    onClick={() =>
                                        this.entrarEmEdicaoDeliberacao(
                                            this.materiaSelecionada,
                                            this.deliberacaoSelecionada
                                        )
                                    }
                                    sx={{ color: blue[800] }}
                                >
                                    <ListItemIcon>
                                        <EditIcon
                                            fontSize="small"
                                            sx={{ color: blue[800] }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText>
                                        Editar descrição da deliberação
                                        <Typography
                                            variant={'caption'}
                                            display={'block'}
                                            fontStyle={'italic'}
                                            color="text.secondary"
                                        >
                                            Altera apenas a descrição
                                        </Typography>
                                    </ListItemText>
                                </MenuItem>
                                <MenuItem
                                    onClick={() =>
                                        this.editarAutorDeliberacao(
                                            this.materiaSelecionada,
                                            this.deliberacaoSelecionada
                                        )
                                    }
                                    sx={{
                                        color: this.isAutorDeliberacaoSelecionadaEhRelator() ? grey[600] : blue[800]
                                    }}
                                    disabled={this.isAutorDeliberacaoSelecionadaEhRelator()}
                                >
                                    <ListItemIcon>
                                        <EditIcon
                                            fontSize="small"
                                            sx={{ color: blue[800] }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText>
                                        Editar autor da deliberação
                                        <Typography
                                            variant={'caption'}
                                            display={'block'}
                                            fontStyle={'italic'}
                                            color="text.secondary"
                                        >
                                            Altera apenas o autor
                                        </Typography>
                                    </ListItemText>
                                </MenuItem>

                                <MenuItem
                                    onClick={() => this.confirmarExclusaoDeliberacao(this.deliberacaoSelecionada)}
                                    sx={{
                                        color: this.isAutorDeliberacaoSelecionadaEhRelator() ? grey[600] : red[800]
                                    }}
                                    disabled={this.isAutorDeliberacaoSelecionadaEhRelator()}
                                >
                                    <ListItemIcon>
                                        <DeleteForeverIcon
                                            fontSize="small"
                                            sx={{ color: red[800] }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText>
                                        Excluir deliberação
                                        <Typography
                                            variant={'caption'}
                                            display={'block'}
                                            fontStyle={'italic'}
                                            color="text.secondary"
                                        >
                                            Exclui a deliberação e os votos associados
                                        </Typography>
                                    </ListItemText>
                                </MenuItem>
                                {!!this.deliberacaoSelecionada?.id && (
                                    <ModalConfirmacao
                                        key={this.deliberacaoSelecionada.id}
                                        open={
                                            !!this.modaisConfirmacaoExclusaoDeliberacaoVoto.get(
                                                this.deliberacaoSelecionada.id
                                            )
                                        }
                                        titulo="Exclusão de deliberação de voto"
                                        tipoConfirmacao={TIPO_CONFIRMACAO.EXCLUSAO}
                                        callbackCancelar={() =>
                                            this.cancelarExclusaoDeliberacao(this.deliberacaoSelecionada)
                                        }
                                        callbackConfirmar={() =>
                                            this.excluirDeliberacao(
                                                this.materiaSelecionada,
                                                this.deliberacaoSelecionada
                                            )
                                        }
                                    >
                                        <Typography display={'inline'}>
                                            Deseja realmente excluir todos os votos associados à deliberação{' '}
                                        </Typography>
                                        <Typography
                                            display={'inline'}
                                            fontWeight={'bold'}
                                            noWrap
                                        >
                                            {this.deliberacaoSelecionada.descricao}
                                        </Typography>
                                        <Typography display={'inline'}>?</Typography>
                                    </ModalConfirmacao>
                                )}
                            </Menu>
                        )}
                        <Menu
                            anchorEl={this.menuMateriaAnchor}
                            open={Boolean(this.menuMateriaAnchor)}
                            onClose={this.fecharMenuMateria}
                        >
                            <MenuItem
                                onClick={() => this.entrarEmEdicaoMateria(this.materiaSelecionada)}
                                sx={{ color: blue[800] }}
                            >
                                <ListItemIcon>
                                    <EditIcon
                                        fontSize="small"
                                        sx={{ color: blue[800] }}
                                    />
                                </ListItemIcon>
                                <ListItemText>
                                    Editar matéria
                                    <Typography
                                        variant={'caption'}
                                        display={'block'}
                                        fontStyle={'italic'}
                                        color="text.secondary"
                                    >
                                        Altera a descrição da matéria
                                    </Typography>
                                </ListItemText>
                            </MenuItem>
                            <MenuItem
                                onClick={() => this.abrirModalAdicionarDeliberacao(this.materiaSelecionada)}
                                sx={{ color: blue[800] }}
                            >
                                <ListItemIcon>
                                    <AddIcon
                                        fontSize="small"
                                        sx={{ color: blue[800] }}
                                    />
                                </ListItemIcon>
                                <ListItemText>
                                    Adicionar deliberação
                                    <Typography
                                        variant={'caption'}
                                        display={'block'}
                                        fontStyle={'italic'}
                                        color="text.secondary"
                                    >
                                        Adiciona sentido de voto
                                    </Typography>
                                </ListItemText>
                            </MenuItem>
                            <MenuItem
                                onClick={() => this.confirmarExclusaoMateria(this.materiaSelecionada)}
                                sx={{ color: red[800] }}
                            >
                                <ListItemIcon>
                                    <DeleteForeverIcon
                                        fontSize="small"
                                        sx={{ color: red[800] }}
                                    />
                                </ListItemIcon>
                                <ListItemText>
                                    Excluir matéria{' '}
                                    <Typography
                                        variant={'caption'}
                                        display={'block'}
                                        fontStyle={'italic'}
                                        color="text.secondary"
                                    >
                                        Exclui a matéria e a votação associada
                                    </Typography>
                                </ListItemText>
                            </MenuItem>
                        </Menu>
                        {!!this.materiaSelecionada?.id && (
                            <ModalConfirmacao
                                key={this.materiaSelecionada.id}
                                open={!!this.modaisConfirmacaoExclusaoMateria.get(this.materiaSelecionada.id)}
                                titulo="Exclusão de matéria"
                                tipoConfirmacao={TIPO_CONFIRMACAO.EXCLUSAO}
                                callbackCancelar={() => this.cancelarExclusaoMateria(this.materiaSelecionada)}
                                callbackConfirmar={() => this.excluirMateria(this.materiaSelecionada)}
                            >
                                <Typography display={'inline'}>
                                    Deseja realmente excluir a votação da matéria{' '}
                                </Typography>
                                <Typography
                                    display={'inline'}
                                    fontWeight={'bold'}
                                    noWrap
                                >
                                    {this.materiaSelecionada.descricao}
                                </Typography>
                                <Typography display={'inline'}>?</Typography>
                            </ModalConfirmacao>
                        )}
                    </DialogPainelVotacaoSessao>
                )}
            </>
        );
    }
}
export default inject('stores')(observer(PainelVotacaoPorMateria));
